/*! Hammer.JS - v2.0.8 - 2016-04-23
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!function(a,b,c,d){"use strict";function e(a,b,c){return setTimeout(j(a,c),b)}function f(a,b,c){return Array.isArray(a)?(g(a,c[b],c),!0):!1}function g(a,b,c){var e;if(a)if(a.forEach)a.forEach(b,c);else if(a.length!==d)for(e=0;e<a.length;)b.call(c,a[e],e,a),e++;else for(e in a)a.hasOwnProperty(e)&&b.call(c,a[e],e,a)}function h(b,c,d){var e="DEPRECATED METHOD: "+c+"\n"+d+" AT \n";return function(){var c=new Error("get-stack-trace"),d=c&&c.stack?c.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",f=a.console&&(a.console.warn||a.console.log);return f&&f.call(a.console,e,d),b.apply(this,arguments)}}function i(a,b,c){var d,e=b.prototype;d=a.prototype=Object.create(e),d.constructor=a,d._super=e,c&&la(d,c)}function j(a,b){return function(){return a.apply(b,arguments)}}function k(a,b){return typeof a==oa?a.apply(b?b[0]||d:d,b):a}function l(a,b){return a===d?b:a}function m(a,b,c){g(q(b),function(b){a.addEventListener(b,c,!1)})}function n(a,b,c){g(q(b),function(b){a.removeEventListener(b,c,!1)})}function o(a,b){for(;a;){if(a==b)return!0;a=a.parentNode}return!1}function p(a,b){return a.indexOf(b)>-1}function q(a){return a.trim().split(/\s+/g)}function r(a,b,c){if(a.indexOf&&!c)return a.indexOf(b);for(var d=0;d<a.length;){if(c&&a[d][c]==b||!c&&a[d]===b)return d;d++}return-1}function s(a){return Array.prototype.slice.call(a,0)}function t(a,b,c){for(var d=[],e=[],f=0;f<a.length;){var g=b?a[f][b]:a[f];r(e,g)<0&&d.push(a[f]),e[f]=g,f++}return c&&(d=b?d.sort(function(a,c){return a[b]>c[b]}):d.sort()),d}function u(a,b){for(var c,e,f=b[0].toUpperCase()+b.slice(1),g=0;g<ma.length;){if(c=ma[g],e=c?c+f:b,e in a)return e;g++}return d}function v(){return ua++}function w(b){var c=b.ownerDocument||b;return c.defaultView||c.parentWindow||a}function x(a,b){var c=this;this.manager=a,this.callback=b,this.element=a.element,this.target=a.options.inputTarget,this.domHandler=function(b){k(a.options.enable,[a])&&c.handler(b)},this.init()}function y(a){var b,c=a.options.inputClass;return new(b=c?c:xa?M:ya?P:wa?R:L)(a,z)}function z(a,b,c){var d=c.pointers.length,e=c.changedPointers.length,f=b&Ea&&d-e===0,g=b&(Ga|Ha)&&d-e===0;c.isFirst=!!f,c.isFinal=!!g,f&&(a.session={}),c.eventType=b,A(a,c),a.emit("hammer.input",c),a.recognize(c),a.session.prevInput=c}function A(a,b){var c=a.session,d=b.pointers,e=d.length;c.firstInput||(c.firstInput=D(b)),e>1&&!c.firstMultiple?c.firstMultiple=D(b):1===e&&(c.firstMultiple=!1);var f=c.firstInput,g=c.firstMultiple,h=g?g.center:f.center,i=b.center=E(d);b.timeStamp=ra(),b.deltaTime=b.timeStamp-f.timeStamp,b.angle=I(h,i),b.distance=H(h,i),B(c,b),b.offsetDirection=G(b.deltaX,b.deltaY);var j=F(b.deltaTime,b.deltaX,b.deltaY);b.overallVelocityX=j.x,b.overallVelocityY=j.y,b.overallVelocity=qa(j.x)>qa(j.y)?j.x:j.y,b.scale=g?K(g.pointers,d):1,b.rotation=g?J(g.pointers,d):0,b.maxPointers=c.prevInput?b.pointers.length>c.prevInput.maxPointers?b.pointers.length:c.prevInput.maxPointers:b.pointers.length,C(c,b);var k=a.element;o(b.srcEvent.target,k)&&(k=b.srcEvent.target),b.target=k}function B(a,b){var c=b.center,d=a.offsetDelta||{},e=a.prevDelta||{},f=a.prevInput||{};b.eventType!==Ea&&f.eventType!==Ga||(e=a.prevDelta={x:f.deltaX||0,y:f.deltaY||0},d=a.offsetDelta={x:c.x,y:c.y}),b.deltaX=e.x+(c.x-d.x),b.deltaY=e.y+(c.y-d.y)}function C(a,b){var c,e,f,g,h=a.lastInterval||b,i=b.timeStamp-h.timeStamp;if(b.eventType!=Ha&&(i>Da||h.velocity===d)){var j=b.deltaX-h.deltaX,k=b.deltaY-h.deltaY,l=F(i,j,k);e=l.x,f=l.y,c=qa(l.x)>qa(l.y)?l.x:l.y,g=G(j,k),a.lastInterval=b}else c=h.velocity,e=h.velocityX,f=h.velocityY,g=h.direction;b.velocity=c,b.velocityX=e,b.velocityY=f,b.direction=g}function D(a){for(var b=[],c=0;c<a.pointers.length;)b[c]={clientX:pa(a.pointers[c].clientX),clientY:pa(a.pointers[c].clientY)},c++;return{timeStamp:ra(),pointers:b,center:E(b),deltaX:a.deltaX,deltaY:a.deltaY}}function E(a){var b=a.length;if(1===b)return{x:pa(a[0].clientX),y:pa(a[0].clientY)};for(var c=0,d=0,e=0;b>e;)c+=a[e].clientX,d+=a[e].clientY,e++;return{x:pa(c/b),y:pa(d/b)}}function F(a,b,c){return{x:b/a||0,y:c/a||0}}function G(a,b){return a===b?Ia:qa(a)>=qa(b)?0>a?Ja:Ka:0>b?La:Ma}function H(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return Math.sqrt(d*d+e*e)}function I(a,b,c){c||(c=Qa);var d=b[c[0]]-a[c[0]],e=b[c[1]]-a[c[1]];return 180*Math.atan2(e,d)/Math.PI}function J(a,b){return I(b[1],b[0],Ra)+I(a[1],a[0],Ra)}function K(a,b){return H(b[0],b[1],Ra)/H(a[0],a[1],Ra)}function L(){this.evEl=Ta,this.evWin=Ua,this.pressed=!1,x.apply(this,arguments)}function M(){this.evEl=Xa,this.evWin=Ya,x.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function N(){this.evTarget=$a,this.evWin=_a,this.started=!1,x.apply(this,arguments)}function O(a,b){var c=s(a.touches),d=s(a.changedTouches);return b&(Ga|Ha)&&(c=t(c.concat(d),"identifier",!0)),[c,d]}function P(){this.evTarget=bb,this.targetIds={},x.apply(this,arguments)}function Q(a,b){var c=s(a.touches),d=this.targetIds;if(b&(Ea|Fa)&&1===c.length)return d[c[0].identifier]=!0,[c,c];var e,f,g=s(a.changedTouches),h=[],i=this.target;if(f=c.filter(function(a){return o(a.target,i)}),b===Ea)for(e=0;e<f.length;)d[f[e].identifier]=!0,e++;for(e=0;e<g.length;)d[g[e].identifier]&&h.push(g[e]),b&(Ga|Ha)&&delete d[g[e].identifier],e++;return h.length?[t(f.concat(h),"identifier",!0),h]:void 0}function R(){x.apply(this,arguments);var a=j(this.handler,this);this.touch=new P(this.manager,a),this.mouse=new L(this.manager,a),this.primaryTouch=null,this.lastTouches=[]}function S(a,b){a&Ea?(this.primaryTouch=b.changedPointers[0].identifier,T.call(this,b)):a&(Ga|Ha)&&T.call(this,b)}function T(a){var b=a.changedPointers[0];if(b.identifier===this.primaryTouch){var c={x:b.clientX,y:b.clientY};this.lastTouches.push(c);var d=this.lastTouches,e=function(){var a=d.indexOf(c);a>-1&&d.splice(a,1)};setTimeout(e,cb)}}function U(a){for(var b=a.srcEvent.clientX,c=a.srcEvent.clientY,d=0;d<this.lastTouches.length;d++){var e=this.lastTouches[d],f=Math.abs(b-e.x),g=Math.abs(c-e.y);if(db>=f&&db>=g)return!0}return!1}function V(a,b){this.manager=a,this.set(b)}function W(a){if(p(a,jb))return jb;var b=p(a,kb),c=p(a,lb);return b&&c?jb:b||c?b?kb:lb:p(a,ib)?ib:hb}function X(){if(!fb)return!1;var b={},c=a.CSS&&a.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(d){b[d]=c?a.CSS.supports("touch-action",d):!0}),b}function Y(a){this.options=la({},this.defaults,a||{}),this.id=v(),this.manager=null,this.options.enable=l(this.options.enable,!0),this.state=nb,this.simultaneous={},this.requireFail=[]}function Z(a){return a&sb?"cancel":a&qb?"end":a&pb?"move":a&ob?"start":""}function $(a){return a==Ma?"down":a==La?"up":a==Ja?"left":a==Ka?"right":""}function _(a,b){var c=b.manager;return c?c.get(a):a}function aa(){Y.apply(this,arguments)}function ba(){aa.apply(this,arguments),this.pX=null,this.pY=null}function ca(){aa.apply(this,arguments)}function da(){Y.apply(this,arguments),this._timer=null,this._input=null}function ea(){aa.apply(this,arguments)}function fa(){aa.apply(this,arguments)}function ga(){Y.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function ha(a,b){return b=b||{},b.recognizers=l(b.recognizers,ha.defaults.preset),new ia(a,b)}function ia(a,b){this.options=la({},ha.defaults,b||{}),this.options.inputTarget=this.options.inputTarget||a,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=a,this.input=y(this),this.touchAction=new V(this,this.options.touchAction),ja(this,!0),g(this.options.recognizers,function(a){var b=this.add(new a[0](a[1]));a[2]&&b.recognizeWith(a[2]),a[3]&&b.requireFailure(a[3])},this)}function ja(a,b){var c=a.element;if(c.style){var d;g(a.options.cssProps,function(e,f){d=u(c.style,f),b?(a.oldCssProps[d]=c.style[d],c.style[d]=e):c.style[d]=a.oldCssProps[d]||""}),b||(a.oldCssProps={})}}function ka(a,c){var d=b.createEvent("Event");d.initEvent(a,!0,!0),d.gesture=c,c.target.dispatchEvent(d)}var la,ma=["","webkit","Moz","MS","ms","o"],na=b.createElement("div"),oa="function",pa=Math.round,qa=Math.abs,ra=Date.now;la="function"!=typeof Object.assign?function(a){if(a===d||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var b=Object(a),c=1;c<arguments.length;c++){var e=arguments[c];if(e!==d&&null!==e)for(var f in e)e.hasOwnProperty(f)&&(b[f]=e[f])}return b}:Object.assign;var sa=h(function(a,b,c){for(var e=Object.keys(b),f=0;f<e.length;)(!c||c&&a[e[f]]===d)&&(a[e[f]]=b[e[f]]),f++;return a},"extend","Use `assign`."),ta=h(function(a,b){return sa(a,b,!0)},"merge","Use `assign`."),ua=1,va=/mobile|tablet|ip(ad|hone|od)|android/i,wa="ontouchstart"in a,xa=u(a,"PointerEvent")!==d,ya=wa&&va.test(navigator.userAgent),za="touch",Aa="pen",Ba="mouse",Ca="kinect",Da=25,Ea=1,Fa=2,Ga=4,Ha=8,Ia=1,Ja=2,Ka=4,La=8,Ma=16,Na=Ja|Ka,Oa=La|Ma,Pa=Na|Oa,Qa=["x","y"],Ra=["clientX","clientY"];x.prototype={handler:function(){},init:function(){this.evEl&&m(this.element,this.evEl,this.domHandler),this.evTarget&&m(this.target,this.evTarget,this.domHandler),this.evWin&&m(w(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&n(this.element,this.evEl,this.domHandler),this.evTarget&&n(this.target,this.evTarget,this.domHandler),this.evWin&&n(w(this.element),this.evWin,this.domHandler)}};var Sa={mousedown:Ea,mousemove:Fa,mouseup:Ga},Ta="mousedown",Ua="mousemove mouseup";i(L,x,{handler:function(a){var b=Sa[a.type];b&Ea&&0===a.button&&(this.pressed=!0),b&Fa&&1!==a.which&&(b=Ga),this.pressed&&(b&Ga&&(this.pressed=!1),this.callback(this.manager,b,{pointers:[a],changedPointers:[a],pointerType:Ba,srcEvent:a}))}});var Va={pointerdown:Ea,pointermove:Fa,pointerup:Ga,pointercancel:Ha,pointerout:Ha},Wa={2:za,3:Aa,4:Ba,5:Ca},Xa="pointerdown",Ya="pointermove pointerup pointercancel";a.MSPointerEvent&&!a.PointerEvent&&(Xa="MSPointerDown",Ya="MSPointerMove MSPointerUp MSPointerCancel"),i(M,x,{handler:function(a){var b=this.store,c=!1,d=a.type.toLowerCase().replace("ms",""),e=Va[d],f=Wa[a.pointerType]||a.pointerType,g=f==za,h=r(b,a.pointerId,"pointerId");e&Ea&&(0===a.button||g)?0>h&&(b.push(a),h=b.length-1):e&(Ga|Ha)&&(c=!0),0>h||(b[h]=a,this.callback(this.manager,e,{pointers:b,changedPointers:[a],pointerType:f,srcEvent:a}),c&&b.splice(h,1))}});var Za={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},$a="touchstart",_a="touchstart touchmove touchend touchcancel";i(N,x,{handler:function(a){var b=Za[a.type];if(b===Ea&&(this.started=!0),this.started){var c=O.call(this,a,b);b&(Ga|Ha)&&c[0].length-c[1].length===0&&(this.started=!1),this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}}});var ab={touchstart:Ea,touchmove:Fa,touchend:Ga,touchcancel:Ha},bb="touchstart touchmove touchend touchcancel";i(P,x,{handler:function(a){var b=ab[a.type],c=Q.call(this,a,b);c&&this.callback(this.manager,b,{pointers:c[0],changedPointers:c[1],pointerType:za,srcEvent:a})}});var cb=2500,db=25;i(R,x,{handler:function(a,b,c){var d=c.pointerType==za,e=c.pointerType==Ba;if(!(e&&c.sourceCapabilities&&c.sourceCapabilities.firesTouchEvents)){if(d)S.call(this,b,c);else if(e&&U.call(this,c))return;this.callback(a,b,c)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var eb=u(na.style,"touchAction"),fb=eb!==d,gb="compute",hb="auto",ib="manipulation",jb="none",kb="pan-x",lb="pan-y",mb=X();V.prototype={set:function(a){a==gb&&(a=this.compute()),fb&&this.manager.element.style&&mb[a]&&(this.manager.element.style[eb]=a),this.actions=a.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var a=[];return g(this.manager.recognizers,function(b){k(b.options.enable,[b])&&(a=a.concat(b.getTouchAction()))}),W(a.join(" "))},preventDefaults:function(a){var b=a.srcEvent,c=a.offsetDirection;if(this.manager.session.prevented)return void b.preventDefault();var d=this.actions,e=p(d,jb)&&!mb[jb],f=p(d,lb)&&!mb[lb],g=p(d,kb)&&!mb[kb];if(e){var h=1===a.pointers.length,i=a.distance<2,j=a.deltaTime<250;if(h&&i&&j)return}return g&&f?void 0:e||f&&c&Na||g&&c&Oa?this.preventSrc(b):void 0},preventSrc:function(a){this.manager.session.prevented=!0,a.preventDefault()}};var nb=1,ob=2,pb=4,qb=8,rb=qb,sb=16,tb=32;Y.prototype={defaults:{},set:function(a){return la(this.options,a),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(a){if(f(a,"recognizeWith",this))return this;var b=this.simultaneous;return a=_(a,this),b[a.id]||(b[a.id]=a,a.recognizeWith(this)),this},dropRecognizeWith:function(a){return f(a,"dropRecognizeWith",this)?this:(a=_(a,this),delete this.simultaneous[a.id],this)},requireFailure:function(a){if(f(a,"requireFailure",this))return this;var b=this.requireFail;return a=_(a,this),-1===r(b,a)&&(b.push(a),a.requireFailure(this)),this},dropRequireFailure:function(a){if(f(a,"dropRequireFailure",this))return this;a=_(a,this);var b=r(this.requireFail,a);return b>-1&&this.requireFail.splice(b,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(a){return!!this.simultaneous[a.id]},emit:function(a){function b(b){c.manager.emit(b,a)}var c=this,d=this.state;qb>d&&b(c.options.event+Z(d)),b(c.options.event),a.additionalEvent&&b(a.additionalEvent),d>=qb&&b(c.options.event+Z(d))},tryEmit:function(a){return this.canEmit()?this.emit(a):void(this.state=tb)},canEmit:function(){for(var a=0;a<this.requireFail.length;){if(!(this.requireFail[a].state&(tb|nb)))return!1;a++}return!0},recognize:function(a){var b=la({},a);return k(this.options.enable,[this,b])?(this.state&(rb|sb|tb)&&(this.state=nb),this.state=this.process(b),void(this.state&(ob|pb|qb|sb)&&this.tryEmit(b))):(this.reset(),void(this.state=tb))},process:function(a){},getTouchAction:function(){},reset:function(){}},i(aa,Y,{defaults:{pointers:1},attrTest:function(a){var b=this.options.pointers;return 0===b||a.pointers.length===b},process:function(a){var b=this.state,c=a.eventType,d=b&(ob|pb),e=this.attrTest(a);return d&&(c&Ha||!e)?b|sb:d||e?c&Ga?b|qb:b&ob?b|pb:ob:tb}}),i(ba,aa,{defaults:{event:"pan",threshold:10,pointers:1,direction:Pa},getTouchAction:function(){var a=this.options.direction,b=[];return a&Na&&b.push(lb),a&Oa&&b.push(kb),b},directionTest:function(a){var b=this.options,c=!0,d=a.distance,e=a.direction,f=a.deltaX,g=a.deltaY;return e&b.direction||(b.direction&Na?(e=0===f?Ia:0>f?Ja:Ka,c=f!=this.pX,d=Math.abs(a.deltaX)):(e=0===g?Ia:0>g?La:Ma,c=g!=this.pY,d=Math.abs(a.deltaY))),a.direction=e,c&&d>b.threshold&&e&b.direction},attrTest:function(a){return aa.prototype.attrTest.call(this,a)&&(this.state&ob||!(this.state&ob)&&this.directionTest(a))},emit:function(a){this.pX=a.deltaX,this.pY=a.deltaY;var b=$(a.direction);b&&(a.additionalEvent=this.options.event+b),this._super.emit.call(this,a)}}),i(ca,aa,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.scale-1)>this.options.threshold||this.state&ob)},emit:function(a){if(1!==a.scale){var b=a.scale<1?"in":"out";a.additionalEvent=this.options.event+b}this._super.emit.call(this,a)}}),i(da,Y,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[hb]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime>b.time;if(this._input=a,!d||!c||a.eventType&(Ga|Ha)&&!f)this.reset();else if(a.eventType&Ea)this.reset(),this._timer=e(function(){this.state=rb,this.tryEmit()},b.time,this);else if(a.eventType&Ga)return rb;return tb},reset:function(){clearTimeout(this._timer)},emit:function(a){this.state===rb&&(a&&a.eventType&Ga?this.manager.emit(this.options.event+"up",a):(this._input.timeStamp=ra(),this.manager.emit(this.options.event,this._input)))}}),i(ea,aa,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[jb]},attrTest:function(a){return this._super.attrTest.call(this,a)&&(Math.abs(a.rotation)>this.options.threshold||this.state&ob)}}),i(fa,aa,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Na|Oa,pointers:1},getTouchAction:function(){return ba.prototype.getTouchAction.call(this)},attrTest:function(a){var b,c=this.options.direction;return c&(Na|Oa)?b=a.overallVelocity:c&Na?b=a.overallVelocityX:c&Oa&&(b=a.overallVelocityY),this._super.attrTest.call(this,a)&&c&a.offsetDirection&&a.distance>this.options.threshold&&a.maxPointers==this.options.pointers&&qa(b)>this.options.velocity&&a.eventType&Ga},emit:function(a){var b=$(a.offsetDirection);b&&this.manager.emit(this.options.event+b,a),this.manager.emit(this.options.event,a)}}),i(ga,Y,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ib]},process:function(a){var b=this.options,c=a.pointers.length===b.pointers,d=a.distance<b.threshold,f=a.deltaTime<b.time;if(this.reset(),a.eventType&Ea&&0===this.count)return this.failTimeout();if(d&&f&&c){if(a.eventType!=Ga)return this.failTimeout();var g=this.pTime?a.timeStamp-this.pTime<b.interval:!0,h=!this.pCenter||H(this.pCenter,a.center)<b.posThreshold;this.pTime=a.timeStamp,this.pCenter=a.center,h&&g?this.count+=1:this.count=1,this._input=a;var i=this.count%b.taps;if(0===i)return this.hasRequireFailures()?(this._timer=e(function(){this.state=rb,this.tryEmit()},b.interval,this),ob):rb}return tb},failTimeout:function(){return this._timer=e(function(){this.state=tb},this.options.interval,this),tb},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==rb&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),ha.VERSION="2.0.8",ha.defaults={domEvents:!1,touchAction:gb,enable:!0,inputTarget:null,inputClass:null,preset:[[ea,{enable:!1}],[ca,{enable:!1},["rotate"]],[fa,{direction:Na}],[ba,{direction:Na},["swipe"]],[ga],[ga,{event:"doubletap",taps:2},["tap"]],[da]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};var ub=1,vb=2;ia.prototype={set:function(a){return la(this.options,a),a.touchAction&&this.touchAction.update(),a.inputTarget&&(this.input.destroy(),this.input.target=a.inputTarget,this.input.init()),this},stop:function(a){this.session.stopped=a?vb:ub},recognize:function(a){var b=this.session;if(!b.stopped){this.touchAction.preventDefaults(a);var c,d=this.recognizers,e=b.curRecognizer;(!e||e&&e.state&rb)&&(e=b.curRecognizer=null);for(var f=0;f<d.length;)c=d[f],b.stopped===vb||e&&c!=e&&!c.canRecognizeWith(e)?c.reset():c.recognize(a),!e&&c.state&(ob|pb|qb)&&(e=b.curRecognizer=c),f++}},get:function(a){if(a instanceof Y)return a;for(var b=this.recognizers,c=0;c<b.length;c++)if(b[c].options.event==a)return b[c];return null},add:function(a){if(f(a,"add",this))return this;var b=this.get(a.options.event);return b&&this.remove(b),this.recognizers.push(a),a.manager=this,this.touchAction.update(),a},remove:function(a){if(f(a,"remove",this))return this;if(a=this.get(a)){var b=this.recognizers,c=r(b,a);-1!==c&&(b.splice(c,1),this.touchAction.update())}return this},on:function(a,b){if(a!==d&&b!==d){var c=this.handlers;return g(q(a),function(a){c[a]=c[a]||[],c[a].push(b)}),this}},off:function(a,b){if(a!==d){var c=this.handlers;return g(q(a),function(a){b?c[a]&&c[a].splice(r(c[a],b),1):delete c[a]}),this}},emit:function(a,b){this.options.domEvents&&ka(a,b);var c=this.handlers[a]&&this.handlers[a].slice();if(c&&c.length){b.type=a,b.preventDefault=function(){b.srcEvent.preventDefault()};for(var d=0;d<c.length;)c[d](b),d++}},destroy:function(){this.element&&ja(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},la(ha,{INPUT_START:Ea,INPUT_MOVE:Fa,INPUT_END:Ga,INPUT_CANCEL:Ha,STATE_POSSIBLE:nb,STATE_BEGAN:ob,STATE_CHANGED:pb,STATE_ENDED:qb,STATE_RECOGNIZED:rb,STATE_CANCELLED:sb,STATE_FAILED:tb,DIRECTION_NONE:Ia,DIRECTION_LEFT:Ja,DIRECTION_RIGHT:Ka,DIRECTION_UP:La,DIRECTION_DOWN:Ma,DIRECTION_HORIZONTAL:Na,DIRECTION_VERTICAL:Oa,DIRECTION_ALL:Pa,Manager:ia,Input:x,TouchAction:V,TouchInput:P,MouseInput:L,PointerEventInput:M,TouchMouseInput:R,SingleTouchInput:N,Recognizer:Y,AttrRecognizer:aa,Tap:ga,Pan:ba,Swipe:fa,Pinch:ca,Rotate:ea,Press:da,on:m,off:n,each:g,merge:ta,extend:sa,assign:la,inherit:i,bindFn:j,prefixed:u});var wb="undefined"!=typeof a?a:"undefined"!=typeof self?self:{};wb.Hammer=ha,"function"==typeof define&&define.amd?define(function(){return ha}):"undefined"!=typeof module&&module.exports?module.exports=ha:a[c]=ha}(window,document,"Hammer");
//# sourceMappingURL=hammer.min.js.map


(function () {
    /**
     * UI elements
     */
    class ME_UI {
        constructor() {
            this.initSmoothScroll();
            this.initFooterSwitch();
            this.initPersonToggle();
            this.initTeacherzoneLoginBox();
            this.initInputsEffect();
            this.initTabAccordion();
            this.initTabCategoriesAccordion();
            this.initOpenContentMenuBar();
            this.initOpenContentMenuSelect();
            this.initYTVideoWithCover();
            this.initReadmoreReadless();
            this.initLoadMore();
            this.initOpenExpandableProductContent();
            this.initOpenExpandableProductList();
            this.initOpenMaterialTools();
            this.initPricesShowMore();
            this.initProductPanelLevel();
            this.initCloseNotification();
            this.initLazyLoadImages();
            this.initTabsExmas();
            this.stickyMenu();
            this.closeInfoBox();
            this.initSmoothScrollHash();
            this.checkInfoSS();
            this.scrollTopButton();
            this.scrolllToLogin();
            this.closeInfoSS();
            this.countInput();
            this.showBookList();
            this.resultsCheckValue();
    
            $(document).on('me-init-input-effect', () => {
                this.initInputsEffect();
            });
        }
    
        closeInfoSS() {
            function setCookie(name, value, days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                const expires = "expires=" + date.toUTCString();
                document.cookie = name + "=" + value + ";" + expires + ";path=/";
            }
    
            function addIdToCookies(containerId) {
                const existingIds = getCookie('selectedContainers') || '';
                const ids = existingIds ? existingIds.split(',') : [];
    
                if (!ids.includes(containerId)) {
                    ids.push(containerId);
                    setCookie('selectedContainers', ids.join(','), 1);
                }
            }
    
            function getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(';').shift();
                return null;
            }
    
            $('.ssinfo').find('.ssinfo-close-btn').on('click', function (e) {
                e.preventDefault();
                $('.ssinfo').css('display', 'none');
                var containerId = $('.ssinfo').attr('data-id');
                addIdToCookies(containerId)
            })
        }
    
        scrolllToLogin() {
            $('.scroll-login').on('click', function (e) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $(".exams-section-login").offset().top - 150
                }, 500);
            })
        }
    
        scrollTopButton() {
            let buttonScroll = document.querySelector('.scroll-to-top');
            if (buttonScroll) {
                buttonScroll.addEventListener('click', (e) => {
                    e.preventDefault();
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                })
    
                window.addEventListener('scroll', function () {
                    let offsetScroll = this.scrollY;
                    if (offsetScroll > 500) {
                        buttonScroll.classList.add('show')
                    } else {
                        buttonScroll.classList.remove('show')
                    }
                })
            }
        }
    
        checkInfoSS() {
            window.addEventListener('DOMContentLoaded', function (e) {
                var header = document.querySelector('#header');
    
                if (header.classList.contains('with-info-bar')) {
                    document.querySelector('#main').classList.remove('without-ssinfo');
                }
            })
        }
    
        stickyMenu() {
            window.addEventListener('scroll', function () {
                var header = $('#header').outerHeight();
                var mobileView = window.matchMedia('(max-width: 560px)');
                if (window.scrollY > 220) {
                    if (!mobileView.matches) {
                        $('.strefa-user-top.type-matura').addClass('sticky');
                        $('.strefa-user-top.type-matura').css('top', `${header}px`);
                    } else {
                        $('.strefa-user-top.type-matura').removeClass('sticky');
                        $('.strefa-user-top.type-matura').removeAttr('style');
                    }
                } else {
                    $('.strefa-user-top.type-matura').removeClass('sticky');
                    $('.strefa-user-top.type-matura').css('top', 'initial');
                }
            });
        }
    
        closeInfoBox() {
            $('.info-box').find('.close').on('click', function (e) {
                e.preventDefault()
                $('.info-box').removeClass('active')
            })
        }
    
        initSmoothScroll() {
            $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top - 170
                        }, 1000);
                    }
                }
            });
        }
    
        initSmoothScrollHash() {
            window.addEventListener('DOMContentLoaded', function () {
                var target = window.location.hash;
                if (target !== '') {
                    $('html, body').animate({
                        scrollTop: $(`${target}`).offset().top - 70
                    }, 1000);
                }
            })
        }
    
        initFooterSwitch() {
            let footerMenu = $('.footer-menu');
            let footerMenuItem = footerMenu.find('.footer-menu-item');
    
            if (!footerMenuItem.length) {
                return
            }
    
            let footerMenuAccordion = footerMenuItem.find('h2');
    
            footerMenuAccordion.on('click', function () {
                $(this).parent().toggleClass('active');
            });
        }
    
        initPersonToggle() {
            let representativesSingle = $('.representatives-single');
            let personToggle = representativesSingle.find('.person-toggle');
            let columnForm = representativesSingle.find('.form');
    
            if (!personToggle.length) {
                return
            }
    
            let personToggleMore = $('.person-toggle__more');
    
            if (personToggle.outerHeight() > columnForm.outerHeight()) {
                $('.person-wrapper').addClass('active')
            } else {
                personToggleMore.on('click', function (e) {
                    e.preventDefault()
                    $(this).closest('.person-toggle').addClass('active');
                });
            }
        }
    
        initTeacherzoneLoginBox() {
            let teacherzoneLoginBox = $('.teacherzone-login .login-box');
            let teacherzoneLoginWrapper = jQuery('.teacherzone-login .wrapper');
            let teacherzoneCircle = $('section.teacherzone-offer .circle');
    
            if (!teacherzoneLoginBox.length) {
                return
            }
    
            $(window).on('scroll', function () {
                if ($(window).width() > 760 && teacherzoneCircle.length) {
                    let top = $(window).scrollTop();
                    let pos = (top - teacherzoneCircle.offset().top) + (teacherzoneCircle.offset().top - teacherzoneLoginWrapper.offset().top) + 60;
                    if (top > teacherzoneLoginWrapper.offset().top - 60) {
                        teacherzoneLoginBox.css('top', (teacherzoneCircle.offset().top - 120 - top > 0 ? pos : teacherzoneCircle.offset().top - teacherzoneLoginWrapper.offset().top - 60) + 'px');
                    }
                    else {
                        teacherzoneLoginBox.css('top', '0');
                    }
                }
                else {
                    teacherzoneLoginBox.css('top', '0');
                }
            }).scroll();
        }
    
        initInputsEffect() {
            let inputsWithEffect = $('.effect .input');
    
            for (let i = 0; i < inputsWithEffect.length; i++) {
                let input = inputsWithEffect.eq(i);
    
                if (input.data('focus-effect-initialized')) {
                    continue;
                }
    
                if (input.val() !== '') {
                    input.addClass('focus');
                }
    
                input.on('focus', function () {
                    $(this).addClass('focus');
                });
    
                input.on('blur', function () {
                    if (this.value === '') {
                        $(this).removeClass('focus');
                    }
                });
    
                input.data('focus-effect-initialized', true);
            }
        }
    
        initTabAccordion() {
            let tabListAccordion = $('ul.accordion');
    
            if (!tabListAccordion.length) {
                return
            }
    
            let tabListAccordionItem = tabListAccordion.find('.accordion-item');
    
            tabListAccordionItem.find('.header').on('click', function () {
                $(this).closest('.accordion-item').toggleClass('active');
            });
        }
    
        initTabCategoriesAccordion() {
            let tabAccordion = $('.tabs-accordion');
    
            if (!tabAccordion.length) {
                return
            }
    
            tabAccordion.each(function () {
                var spis = $(this);
    
                if (spis.find('.categories > li.active').length < 1) {
                    spis.find('.categories > li').eq(0).addClass('active');
                    spis.find('.articles > li').eq(0).addClass('active');
                }
    
                spis.find('.categories > li a').on('click', function (e) {
                    e.preventDefault();
    
                    var index = $(this).closest('li').index('.categories > li');
    
                    spis.find('.categories > li').removeClass('active');
                    spis.find('.categories > li').eq(index).addClass('active');
    
                    spis.find('.articles > li').removeClass('active');
                    spis.find('.articles > li').eq(index).addClass('active');
                });
            });
        }
    
        initOpenContentMenuBar() {
            let contentMenuBar = $('.content-menu-bar');
    
            if (!contentMenuBar.length) {
                return
            }
    
            let openContentMenuBar = contentMenuBar.find('.current-tab');
            let contentMenuBarList = contentMenuBar.find('ul');
            let contentMenuBarItem = contentMenuBar.find('li a');
    
            openContentMenuBar.on('click', function () {
                contentMenuBarList.toggleClass('active');
            });
    
            for (let i = 0; i < contentMenuBarItem.length; i++) {
                contentMenuBarItem.eq(i).on('click', () => {
                    contentMenuBarList.removeClass('active');
                });
            }
        }
    
        initOpenContentMenuSelect() {
            let contentMenuSelect = $('.content-menu-select');
    
            if (!contentMenuSelect.length) {
                return
            }
    
            let opencontentMenuSelect = contentMenuSelect.find('.current-tab');
            let contentMenuSelectList = contentMenuSelect.find('ul');
            let contentMenuSelectItem = contentMenuSelect.find('li a');
    
            opencontentMenuSelect.on('click', function () {
                contentMenuSelectList.toggleClass('active');
            });
    
            for (let i = 0; i < contentMenuSelectItem.length; i++) {
                contentMenuSelectItem.eq(i).on('click', () => {
                    contentMenuSelectList.removeClass('active');
                    let currentMenuItemText = contentMenuSelectItem.eq(i).text();
                    opencontentMenuSelect.text(currentMenuItemText);
                });
            }
        }
    
        initYTVideoWithCover() {
            let videos = $('.default-video-wrapper .cover');
    
            if (!videos.length) {
                return;
            }
    
            for (let i = 0; i < videos.length; i++) {
                let cover = videos.eq(i);
    
                videos.eq(i).on('click', e => {
                    e.preventDefault();
                    cover.addClass('is-hidden');
                    let iframe = cover.parent().find('iframe');
    
                    iframe.on('load', function () {
                        setTimeout(() => {
                            iframe[0].contentWindow.postMessage(JSON.stringify({
                                'event': 'command',
                                'func': 'playVideo',
                                'args': []
                            }), '*');
                        }, 500);
                    });
    
                    iframe.attr('src', iframe.attr('data-src'));
                });
            }
        }
    
        initReadmoreReadless() {
            let btnShowMore = $('.btn-show-more');
    
            if (!btnShowMore.length) {
                return;
            }
    
            for (let i = 0; i < btnShowMore.length; i++) {
                btnShowMore.eq(i).on('click', e => {
                    e.preventDefault();
                    let clickedBtnShowMore = $(e.target);
    
                    if (clickedBtnShowMore.hasClass('active')) {
                        clickedBtnShowMore.removeClass('active');
                        clickedBtnShowMore.parent().find('.full-text').removeClass('active');
                    } else {
                        clickedBtnShowMore.addClass('active');
                        clickedBtnShowMore.parent().find('.full-text').addClass('active');
                    }
                });
            }
        }
    
        initLoadMore() {
            let loadMoreLink = $('.view-more');
    
            if (!loadMoreLink.length) {
                return;
            }
    
            loadMoreLink.on('click', (e) => {
                e.preventDefault();
                $(e.target).addClass('active');
            })
        }
    
        initOpenExpandableProductContent() {
            let btnExpandalbe = $('.product-content-sections-wrapper__button');
            let productContentExpandable = $('.product-content-sections-wrapper--expandable');
    
            if (!btnExpandalbe.length) {
                return;
            }
    
            btnExpandalbe.on('click', e => {
                e.preventDefault()
                productContentExpandable.addClass('active');
                $(this).closest('#main').find('.hide-description-section').removeClass('hidden');
                $(this).remove()
            })
        }
    
        initOpenExpandableProductList() {
            let btnExpandableList = $('.product-default__show-more');
    
            if (!btnExpandableList.length) {
                return;
            }
    
            btnExpandableList.on('click', (e) => {
                e.preventDefault();
                $(e.target).parents('.product-default-component__content').find('.product-expandable-list').addClass('active');
                $(e.target).remove();
            })
        }
    
        initOpenMaterialTools() {
            let btnOpenMaterialTools = $('.product-material-tools__table__show-more-trigger');
    
            if (!btnOpenMaterialTools.length) {
                return;
            }
    
            btnOpenMaterialTools.on('click', (e) => {
                e.preventDefault();
                $(e.target).prev('.product-material-tools__table').addClass('active');
                $(e.target).remove();
            });
        }
    
        initPricesShowMore() {
            let btnPricesShowMore = $('.product-prices__show-more');
    
            if (!btnPricesShowMore.length) {
                return;
            }
    
            btnPricesShowMore.on('click', (e) => {
                e.preventDefault();
                $('.product-prices').addClass('active');
                $(e.target).remove();
            })
        }
    
        initProductPanelLevel() {
            $('ul.product-panel__levels li').click((e) => {
                var level_index = $(e.target).data('level');
    
                $('ul.product-panel__levels li').removeClass('active');
                $('ul.product-panel__levels li[data-level="' + level_index + '"]').addClass('active');
    
                $('.level-p').addClass('hidden');
                $('.level-p.level-p-' + level_index).removeClass('hidden');
    
                $('.row_level').addClass('hidden');
                $('.row_level_' + (level_index)).removeClass('hidden');
    
            });
        }
    
        initCloseNotification() {
            let notificationBar = $('.teacherzone-notification');
    
            if (!notificationBar.length) {
                return;
            }
    
            let closeNotificationBar = notificationBar.find('.close');
    
            closeNotificationBar.on('click', (e) => {
                e.preventDefault();
                closeNotificationBar.parents('.teacherzone-notification').addClass('hidden');
            });
        }
    
        // initTextAccordion () {
        //   if ($(document.body).hasClass('js-ui-accordion-initialized')) {
        //     return;
        //   }
    
        //   $(document.body).addClass('js-ui-accordion-initialized');
    
        //   $(".js-accordion").each(function(i, item) {
        //     $(item).find('.js-accordion-content').css('height', 0);
    
        //     $(item).on("click", function () {
        //       let item = $(this);
        //       let contentWrapper = item.find('.js-accordion-content');
        //       let contentText = item.find('.js-accordion-content > div');
    
        //       item.toggleClass('active');
        //       let newHeight = contentText.outerHeight();
    
        //       if (item.hasClass('active')) {
        //         contentWrapper.css('height', 0);
    
        //         setTimeout(function() {
        //           contentWrapper.css('height', newHeight + 'px');
        //         }, 0);
    
        //         setTimeout(function() {
        //           contentWrapper.css('height', 'auto');
        //         }, 500);
        //       } else {
        //         contentWrapper.css('height', newHeight + 'px');
    
        //         setTimeout(function() {
        //           contentWrapper.css('height', 0);
        //         }, 0);
        //       }
        //     });
        //   });
        // }
    
        initLazyLoadImages() {
            $(window).on('load', function () {
                $('img.lazy').each(function () {
                    $(this).attr('src', $(this).attr('lazy-src'));
                    $(this).addClass('lazy-loaded')
                });
                $('.lazy-bg').each(function () {
                    $(this).attr('style', $(this).data('bg'));
                    $(this).addClass('lazy-loaded')
                });
            });
        }
    
        initTabsExmas() {
            let tabs = $('.tabs');
    
            if (!tabs.length) {
                return;
            }
    
            $('.tabs .tabs-navigation li').first().addClass('active');
            $('.tabs .tabs-contents .tab').first().addClass('active');
    
            $('.tabs-navigation .tab').on('click', function () {
                var index = $(this).index();
                var container = $(this).closest('.tabs');
    
                container.find('.tabs-navigation li').removeClass('active');
                container.find('.tabs-navigation li').eq(index).addClass('active');
    
                container.find('.tabs-contents .tab').removeClass('active');
                container.find('.tabs-contents .tab').eq(index).addClass('active');
            });
        }
    
        countInput() {
            let countInput = document.querySelectorAll('.count-input');
            if (countInput.length > 0) {
                for (let i = 0; i < countInput.length; i++) {
                    let btnPlus = countInput[i].querySelector('.count-plus');
                    let btnMinus = countInput[i].querySelector('.count-minus');
                    let changeInput = countInput[i].querySelector('input[type="number"]');
    
                    btnPlus.addEventListener('click', function (e) {
                        e.preventDefault();
                        changeInput.value = Number(changeInput.value) + Number(1);
                        changeInput.dispatchEvent(new Event('input', { bubbles: true }));
                        changeInput.dispatchEvent(new Event('change', { bubbles: true }));
                    })
    
                    btnMinus.addEventListener('click', function (e) {
                        e.preventDefault();
                        if (changeInput.value <= 0) {
                            return
                        } else {
                            changeInput.value = Number(changeInput.value) - Number(1);
                            changeInput.dispatchEvent(new Event('input', { bubbles: true }));
                            changeInput.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    })
                }
            }
        }
    
        showBookList() {
            let declarationForm = document.querySelectorAll('.declaration-form');
            if (declarationForm.length > 0) {
                for (let f = 0; f < declarationForm.length; f++) {
                    let booksElement = declarationForm[f].querySelector('.choose-books-list');
                    let booksForm = declarationForm[f].querySelector('.books');
                    let booksTable = booksForm.querySelector('.table');
                    let bookItem = booksTable.querySelectorAll('.declaration-order');
                    let href;
                    if (booksElement) {
                        booksElement.querySelector('.activator').addEventListener('click', function (e) {
                            booksElement.classList.toggle('show');
                        })
    
                        let booksList = booksElement.querySelector('ul');
                        let booksButton = booksList.querySelectorAll('.book-button');
    
                        if (booksButton.length > 0) {
                            for (let b = 0; b < booksButton.length; b++) {
                                booksButton[b].addEventListener('click', function (e) {
                                    e.preventDefault();
                                    booksElement.classList.remove('show');
                                    href = booksButton[b].getAttribute('data-book-button-id');
    
                                    booksTable.classList.add('show');
                                    booksTable.querySelector(`.declaration-order[data-book-id="${href}"]`).classList.add('show');
                                })
                            }
                        }
                    }
    
                    if (bookItem.length > 0) {
                        for (let r = 0; r < bookItem.length; r++) {
                            let removeButton = bookItem[r].querySelector('.remove-book');
                            let bookValue = bookItem[r].querySelector('input[type="number"]');
                            removeButton.addEventListener('click', function (e) {
                                e.preventDefault();
                                removeButton.closest('.declaration-order').classList.remove('show');
                                bookValue.value = 0;
    
                                if (document.querySelectorAll(`.declaration-order.show`).length <= 0) {
                                    booksTable.classList.remove('show');
                                }
                            })
                        }
                    }
                }
            }
        }
    
        resultsCheckValue() {
            let resultInput = document.querySelectorAll('.results-input');
            if (resultInput.length > 0) {
                for (let i = 0; i < resultInput.length; i++) {
                    if (Number(resultInput[i].value) === 0) {
                        resultInput[i].removeAttribute('value');
                        resultInput[i].setAttribute('placeholder', '0');
                    };
    
                    resultInput[i].addEventListener('focus', function (e) {
                        if (Number(resultInput[i].value) === 0) {
                            resultInput[i].removeAttribute('placeholder');
                        }
                    });
    
                    resultInput[i].addEventListener('focusout', function (e) {
                        if (Number(resultInput[i].value) === 0) {
                            resultInput[i].setAttribute('placeholder', '0');
                        }
                    });
                }
            }
        }
    }
    
    /**
     * Menu script
     */
     class ME_Menu {
    	constructor() {
    		this.initState();
    		this.initEvents();
    	}
    
    	initState() {
    		this.win = $(window);
    		this.menuWrapper = $('#header');
    		this.menuIcon = this.menuWrapper.find('.mobile-menu-wrapper');
    		this.menuBlock = this.menuWrapper.find('.bottom-menu');
    		this.menuBlockClose = this.menuBlock.find('.bottom-menu-close');
    	}
    
    	initEvents() {
    		$(window).on('scroll', () => {
    			let positionY = this.win.scrollTop();
    
    			if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
    					this.menuWrapper.addClass('is-fixed');
    					return;
    			}
    
    			if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
    					this.menuWrapper.removeClass('is-fixed');
    			}
    	});
    	
    		this.menuIcon.on('click', e => {
    			e.preventDefault();
    			this.menuBlock.toggleClass('active');
    			$(document.body).toggleClass('no-scroll');
    		});
    
    		if (this.menuBlockClose.length) {
    			this.menuBlockClose.on('click', e => {
    				e.preventDefault();
    				this.menuBlock.removeClass('active');
    				this.menuBlock.find('.menu-left > li').removeClass('mobile-active');
    				$(document.body).removeClass('no-scroll');
    			});
    		}
    
    		this.menuBlock.find('.bottom-menu-back').on('click', e => {
    			e.preventDefault();
    			this.menuBlock.removeClass('submenu');
    			this.menuBlock.find('.menu-left > li').removeClass('mobile-active');
    		})
    	
    		this.menuBlock.find('.menu-left .deeper.parent > a').on('click', e => {
    			let submenuLink = $(e.target);
    			var submenuLinkParent = submenuLink.parent();
    			var isMobile = $(window).outerWidth() <= 1024;
    	
    			if (isMobile && !submenuLinkParent.hasClass('mobile-active')) {
    				e.preventDefault();
    				this.menuBlock.addClass('submenu');
    				this.menuBlock.find('.menu-left > li').removeClass('mobile-active');
    				submenuLinkParent.addClass('mobile-active');
    			}
    		})
    	}
    }
    
    /**
     * Search script
     */
    class ME_Search {
        constructor() {
            this.initState();
            this.initEvents();
            this.initSearchResult();
        }
    
        initState() {
            this.win = $(window);
            this.searchWrapper = $('.search.main');
            this.searchInput = this.searchWrapper.find('.input');
            this.searchForm = this.searchWrapper.find('form');
            this.searchResultPage = $('#search-results-list');
            this.currentHighlight = -1;
        }
    
        initEvents() {
            if (!this.searchInput.length) {
                return
            }
    
            this.searchInput.on('change, keyup', (e) => {
                let phrase = $(e.target).val();
                let keyCode = e.keyCode;
                let formUrl = this.searchForm.data('ajax-url');
    
                if (keyCode != 38 && keyCode != 40 && keyCode != 13) {
                    this.highlightReset();
    
                    if (phrase.length >= 3) {
                        $.ajax({
                            url: formUrl,
                            type: 'GET',
                            dataType: 'json',
                            data: {
                                searchword: phrase,
                                tmpl: 'json',
                                limit: 8
                            },
                        })
                            .done(function (response) {
                                $('.hints-list li').remove();
                                $('.hints-list').append(response.html);
                                $('.hints-list').addClass('active');
                                $('.hints-list').highlight(phrase);
                            })
                            .fail(function () {
                                console.log("error");
                            });
                    } else {
                        $('.hints-list').removeClass('active');
                        $('.hints-list li').remove();
                    }
                }
            });
    
            this.searchInput.on('click blur', () => {
                this.highlightReset();
            });
    
            this.searchForm.on('submit', (e) => {
                e.preventDefault();
    
                if ($('.hints-list .hint.active').length > 0) {
                    let url = $('.hints-list .hint.active').first().find('a').attr('href');
                    this.win.location.href = url;
                }
                else {
                    this.searchWrapper.find('form')[0].submit();
                }
            });
    
            this.searchInput.on('keydown', (e) => {
                let keyCode = e.keyCode;
    
                if (keyCode == 40) {
                    this.highlightNext();
                }
    
                if (keyCode == 38) {
                    this.highlightPrev();
                }
            });
        }
    
        highlightNext() {
            this.currentHighlight += 1;
            let total = $('.hints-list .hint').length
    
            if (this.currentHighlight >= total) {
                this.currentHighlight = total - 1;
            }
    
            $('.hints-list .hint').removeClass('active');
            $('.hints-list .hint').eq(this.currentHighlight).addClass('active');
        }
    
        highlightPrev() {
            this.currentHighlight -= 1;
    
            if (this.currentHighlight <= 0) {
                this.currentHighlight = 0;
            }
    
            $('.hints-list .hint').removeClass('active');
            $('.hints-list .hint').eq(this.currentHighlight).addClass('active');
        }
    
        highlightReset() {
            this.currentHighlight = -1;
            $('.hints-list .hint').removeClass('active');
        }
    
        initSearchResult() {
            if (!this.searchResultPage.length) {
                return
            }
    
            let searchResultPagePhrase = this.searchResultPage.attr('search-phrase');
            console.log('phrase', this.searchResultPagePhrase);
            console.log('list', this.searchResultPage);
            this.searchResultPage.eq(0).highlight(searchResultPagePhrase, 'highlighted');
        }
    }
    
    class ME_FormHelper {
        constructor(formElement) {
            this.formElement = formElement;
            this.rules = {
                multiCheckboxRequired: {
                    validator: (value, field) => {
                        let selectedValueExists = field.parents('.form-item').find('input[type="checkbox"]:checked').length;
                        return !!selectedValueExists;
                    },
                    errorText: 'Co najmniej jedno z pól jest wymagane'
                },
                multiNumberRequired: {
                    validator: (value, field) => {
                        console.log('validate field', field, value);
                        let fields = field.parents('.form-item').find('input[type="number"]');
    
                        for (let i = 0; i < fields.length; i++) {
                            if (fields.eq(i).val()) {
                                console.log('ok');
                                return true;
                            }
                        }
    
                        console.log('not ok');
                        return false;
                    },
                    errorText: 'Jedno z pól musi mieć wartość powyżej 0'
                },
                required: {
                    validator: (value, field) => {
                        if (field.attr('type') === 'checkbox') {
                            return field.prop('checked');
                        }
    
                        if (field.attr('type') === 'radio') {
                            let selectedValueExists = field.parents('.form-item').find('input[type="radio"]:checked').length;
                            return !!selectedValueExists;
                        }
    
                        if (field.attr('type') === 'select') {
                            let selectedValueExists = field.parents('.form-item').find('select').val();
                            return selectedValueExists !== null;
                        }
    
                        if (field.attr('type') === 'file') {
                            let selectedFileExists = field[0].files.length;
                            return !!selectedFileExists;
                        }
    
                        return !!value;
                    },
                    errorText: 'Pole jest wymagane'
                },
                requiredIfDateToVisible: {
                    validator: (value, field) => {
                        let dateToField = field.parents('form').find('[data-val-name="date_to"]');
    
                        if (dateToField.length && dateToField.hasClass('is-hidden')) {
                            return true;
                        }
    
                        return !!value;
                    },
                    errorText: 'Pole jest wymagane'
                },
                min: {
                    validator: (value, range) => parseFloat(value) >= parseFloat(range),
                    errorText: (range) => 'Wartość nie może być mniejsza niż ' + range
                },
                max: {
                    validator: (value, range) => parseFloat(value) <= parseFloat(range),
                    errorText: (range) => 'Wartość nie może być większa niż ' + range
                },
                email: {
                    validator: (value) => value.indexOf('@') > 0 && value.indexOf('.') > -1,
                    errorText: 'Podaj prawidłowy adres e-mail'
                },
                postcode: {
                    validator: (value) => typeof value === "string" && (new RegExp(/^[0-9]{2,2}\-[0-9]{3,3}$/gmi).test(value) || new RegExp(/^[0-9]{5,5}$/gmi).test(value)),
                    errorText: 'Kod pocztowy musi być podany w formacie XX-XXX'
                },
                phone: {
                    validator: (value) => typeof value === "string" && new RegExp(/^[0-9]{9}$/gmi).test(value.replace(/\D/g, '')),
                    errorText: 'Numer telefonu musi posiadać 9 cyfr'
                }
            };
            this.dependencies = {};
        }
    
        formDependencies(config) {
            for (let i = 0; i < config.length; i++) {
                if (config[i].useCollection) {
                    let triggerSelector = config[i].dependsOn;
                    let fieldName = config[i].field.replace(/[^a-z0-9\_\-]/gmi, '');
                    let callback = config[i].elementsToShow;
                    let triggerElement = this.formElement.find(triggerSelector);
                    let fieldElements = this.formElement.find('*[data-val-name="' + fieldName + '"]');
    
                    triggerElement.on('input', (e) => {
                        fieldElements.addClass('is-hidden');
    
                        for (let j = 0; j < fieldElements.length; j++) {
                            this.resetField(fieldElements.eq(j));
                        }
    
                        let elementsToShow = callback($(e.target).val());
                        elementsToShow.removeClass('is-hidden');
                    });
                } else {
                    let triggerSelector = config[i].dependsOn;
                    let fieldName = config[i].field.replace(/[^a-z0-9\_\-]/gmi, '');
                    let callback = config[i].showOn;
                    let triggerElement = this.formElement.find(triggerSelector);
                    let fieldElement = this.formElement.find('*[data-val-name="' + fieldName + '"]');
    
                    triggerElement.on('input', (e) => {
                        if (callback($(e.target).val())) {
                            fieldElement.removeClass('is-hidden');
                        } else {
                            fieldElement.addClass('is-hidden');
                            this.resetField(fieldElement);
                        }
                    });
                }
            }
        }
    
        resetField(fieldWrapper) {
            if (fieldWrapper.find('input').length) {
                if (fieldWrapper.find('input').attr('type') === 'radio') {
                    fieldWrapper.find('input').prop('checked', false);
                } else {
                    fieldWrapper.find('input').val('');
                }
    
                fieldWrapper.find('input').trigger('input');
            } else if (fieldWrapper.find('select').length) {
                fieldWrapper.find('select').val('');
                fieldWrapper.find('select').trigger('input');
            } else if (fieldWrapper.find('textarea').length) {
                fieldWrapper.find('textarea').val('');
                fieldWrapper.find('textarea').trigger('input');
            }
        }
    
        formValidate() {
            // pobieramy wszystkie pole
            let fields = this.formElement.find('*[data-val-validation]');
            let formIsValid = true;
    
            for (let i = 0; i < fields.length; i++) {
                // pomijamy ukryte pola
                if (fields.eq(i).parents('[data-val-name]').hasClass('is-hidden')) {
                    continue;
                }
    
                // pomijamy ukryte pola
                if (fields.eq(i).parent().hasClass('is-hidden')) {
                    continue;
                }
    
                let fieldValue = fields.eq(i).val();
                let validationRules = fields.eq(i).attr('data-val-validation');
                validationRules = validationRules.split('|');
                let fieldIsValid = true;
                let fieldErrorMessage = fields.eq(i).parents('.form-item').find('.validation-error');
    
                for (let j = 0; j < validationRules.length; j++) {
                    let validationRule = validationRules[j];
    
                    if (validationRule.indexOf(':') > -1) {
                        let ruleName = validationRule.split(':')[0];
                        let range = validationRule.split(':')[1];
    
                        if (!this.rules[ruleName].validator(fieldValue, range)) {
                            fieldIsValid = false;
                            fieldErrorMessage.text(this.rules[ruleName].errorText(range));
                            break;
                        }
                    } else {
                        if (!this.rules[validationRule].validator(fieldValue, fields.eq(i))) {
                            fieldIsValid = false;
                            fieldErrorMessage.text(this.rules[validationRule].errorText);
                            break;
                        }
                    }
                }
    
                if (fieldIsValid) {
                    fieldErrorMessage.addClass('is-hidden');
                    fieldErrorMessage.text('');
                } else {
                    formIsValid = false;
                    fieldErrorMessage.removeClass('is-hidden');
                    fields.eq(i).one('input', () => {
                        fieldErrorMessage.addClass('is-hidden');
                        fieldErrorMessage.text('');
                    });
                }
            }
    
            return formIsValid;
        }
    }
    
    /**
     * Cover Tabs script
     */
     class ME_CoverTabs {
      constructor() {
        this.initState();
        this.initEvents();
      }
    
      initState() {
        this.tablinksWrapper = $('.tabs__tablinks');
      }
    
      initEvents() {
        if (!this.tablinksWrapper) {
          return;
        }
    
        for (let i = 0; i < this.tablinksWrapper.length; i++) {
          if (!this.tablinksWrapper.eq(i).attr('data-js-initialized')) {
            this.tablinksWrapper.eq(i).attr('data-js-initialized', true);
            let tablinks = this.tablinksWrapper.eq(i).find('.tabs__tablinks-item');
    
            for (let j = 0; j < tablinks.length; j++) {
              tablinks.eq(j).on('click', this.showTab.bind(this));
            }
          }
        }
      }
    
      showTab(e) {
        let tabID = $(e.target).attr('data-id');
        let wrapper = $(e.target).parents('.cover-tabs');
        let wrapperID = wrapper.attr('data-tablinks');
        let tabContent = wrapper.find('.tabs__content[data-id="' + tabID + '"]');
        let tabs = wrapper.find('.tabs__tablinks-item');
        let content = wrapper.find('.tabs__content');
    
        if (tabID) {
          tabID = tabID.replace(/[^a-z0-9\-]/gmi, '');
        }
    
        if (wrapperID) {
          wrapperID = wrapperID.replace(/[^a-z0-9\-]/gmi, '');
        }
    
        for (let i = 0; i < tabs.length; i++) {
          tabs.eq(i).removeClass('is-active');
          content.eq(i).removeClass('is-showing');
          content.eq(i).removeClass('is-active');
          content.eq(i).attr('data-current-item', '0');
        }
    
        $(e.target).addClass('is-active');
        tabContent.addClass('is-active');
    
        setTimeout(() => {
          tabContent.addClass('is-showing');
        }, 200);
      }
    }
    
    /**
     * Home articels slider script
     */
    class ME_HomeArticlesSlider {
        constructor() {
            this.initState();
            this.initEvents();
        }
    
        initState() {
            this.sliderWrapper = $('.home-articles-slider');
            this.list = this.sliderWrapper.find('.articles-list');
            this.items = this.list.find('.articles-item');
            this.dots = this.sliderWrapper.find('.dot');
            this.nextBtn = this.sliderWrapper.find('.next');
            this.currentItem = 0;
            this.animationInProgress = false;
        }
    
        initEvents() {
            if (this.sliderWrapper.length) {
                this.initUI();
            }
        }
    
        initUI() {
            this.swipeEffect = new Hammer(this.sliderWrapper[0]);
    
            setTimeout(() => {
                this.showNextSlide();
            }, 3500);
    
            this.nextBtn.on('click', e => {
                e.preventDefault();
    
                if (e.originalEvent) {
                    this.blankSlide = true;
                }
    
                if (this.animationInProgress) {
                    return;
                }
    
                this.currentItem++;
                this.animationInProgress = true;
    
                if (this.currentItem >= this.items.length) {
                    this.currentItem = 0;
                }
    
                this.dots.removeClass('is-active');
                this.dots.eq(this.currentItem).addClass('is-active');
                this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
                setTimeout(() => {
                    this.animationInProgress = false;
                }, 550);
            });
    
            for (let i = 0; i < this.dots.length; i++) {
                this.dots.eq(i).on('click', e => {
                    e.preventDefault();
    
                    if (e.originalEvent) {
                        this.blankSlide = true;
                    }
    
                    if (this.animationInProgress) {
                        return;
                    }
    
                    this.currentItem = i;
                    this.animationInProgress = true;
                    this.dots.removeClass('is-active');
                    this.dots.eq(this.currentItem).addClass('is-active');
                    this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
                    setTimeout(() => {
                        this.animationInProgress = false;
                    }, 550);
                });
            }
    
            this.swipeEffect.on('swipe', ev => {
                if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
                    if (this.currentItem < this.dots.length) {
                        this.currentItem++;
                    } else {
                        this.currentItem = 0;
                    }
    
                    this.dots.eq(this.currentItem).trigger('click');
                }
    
                if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
                    if (this.currentItem > 0) {
                        this.currentItem--;
                    } else {
                        this.currentItem = this.dots.length;
                    }
    
                    this.dots.eq(this.currentItem).trigger('click');
                }
            });
        }
    
        showNextSlide () {
            if (this.blankSlide) {
                this.blankSlide = false;
            } else {
                this.nextBtn.trigger('click');
            }
    
            setTimeout(() => {
                this.showNextSlide();
            }, 4000);
        }
    }
    
    /**
     * Articels slider script
     */
    class ME_ArticlesSlider {
    	constructor() {
    		this.initState();
    		this.initEvents();
    	}
    
    	initState() {
    		this.sliderWrapper = $('.mobile-articles-slider');
    		this.prev = this.sliderWrapper.find('.prev');
    		this.next = this.sliderWrapper.find('.next');
    		this.list = this.sliderWrapper.find('.articles-list');
    		this.items = this.list.find('.articles-item');
    		this.currentItem = 0;
    		this.animationInProgress = false;
    	}
    
    	initEvents() {
    		this.phoneViewport = window.matchMedia("screen and (max-width: 560px)");
    
    		if (this.sliderWrapper.length) {
    			if (this.phoneViewport.matches) {
    				this.initUI();
    			}
    
    			this.phoneViewport.addListener((mq) => {
    				if (mq.matches) {
    					this.initUI();
    				} else {
    					this.list.css('margin-left', 0);
    
    					for (let i = 0; i < this.dots.length; i++) {
    						this.items.removeClass('is-active');
    						this.items.eq(0).addClass('is-active');
    					}
    				}
    			});
    		}
    	}
    
    	initUI () {
    		this.swipeEffect = new Hammer(this.sliderWrapper[0]);
    
    		this.prev.on('click', e => {
    			e.preventDefault();
    
    			if (this.animationInProgress) {
    				return;
    			}
    
    			this.currentItem--;
    			this.animationInProgress = true;
    
    			if (this.currentItem <= 0) {
    				this.prev.addClass('is-hidden');
    			}
    
    			this.next.removeClass('is-hidden');
    			this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
    			setTimeout(() => {
    				this.animationInProgress = false;
    			}, 550);
    		});
    
    		this.next.on('click', e => {
    			e.preventDefault();
    
    			if (this.animationInProgress) {
    					return;
    			}
    
    			this.currentItem++;
    			this.animationInProgress = true;
    
    			if (this.currentItem == this.items.length - 1) {
    				this.next.addClass('is-hidden');
    			}
    
    			this.prev.removeClass('is-hidden');
    			this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
    			setTimeout(() => {
    				this.animationInProgress = false;
    			}, 550);
    		});
    
    		this.swipeEffect.on('swipe', ev => {
    			if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
    				this.next.trigger('click');
    			}
    
    			if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
    				this.prev.trigger('click');
    			}
    		});
    	}
    }
    
    /**
     * Teacherzone slider script
     */
    class ME_TeacherzoneSlider {
    	constructor(slider_container) {
    		this.initState(slider_container);
    	}
    
    	initState(slider_container) {
    		this.sliderSection = slider_container;
    		this.slider = this.sliderSection.find('.slider');
    		this.slides = this.slider.find('li');
    		this.first = 0;
    		this.second = 1;
    		this.third = 2;
    		this.last = this.slides.length - 1;
    		this.controls = this.sliderSection.find('.controls');
    		this.navigation = this.controls.find('.navigation');
    		this.prev = this.controls.find('.prev');
    		this.next = this.controls.find('.next');
    		this.animationInProgress = false;
    
    		if (this.sliderSection.length && this.slides.length > 1) {
    			for (let i = 0; i < this.slides.length; i++) {
    				this.navigation.append('<li></li>');
    			}
    
    			this.navigationItem = this.navigation.find('li');
    			this.navigationItem.first().addClass('active');
    
    			setTimeout(() => {
    				this.initEvents();
    			},0);
    		} else {
    			if(this.slides.length <= 1) {
    				this.prev.addClass('is-hidden');
    				this.next.addClass('is-hidden');
    			}
    		}
    	}
    
    	initEvents() {
    		setTimeout(() => {
    			this.startMotion();
    		}, 500);
    
    		this.next.on('click', () => {
    			if (this.animationInProgress) {
    				return;
    			}
    
    			this.slides.addClass('motion');
    			this.navigationItem.removeClass('active');
    
    			this.first = (this.first + 1) % this.slides.length;
    			this.second = (this.second + 1) % this.slides.length;
    			this.third = (this.third + 1) % this.slides.length;
    			this.last = (this.last + 1) % (this.slides.length);
    
    			this.navigationItem.eq(this.first).addClass('active');
    
    			setTimeout(() => {
    				this.animationInProgress = false;
    				this.startMotion();
    			}, 500);
    		})
    
    		this.prev.on('click', () => {
    			if (this.animationInProgress) {
    				return;
    			}
    
    			this.slides.addClass('motion');
    			this.navigationItem.removeClass('active');
    			setTimeout(() => {
    				this.animationInProgress = false;
    				this.startMotion();
    			}, 500);
    
    			this.first = (this.first - 1) % this.slides.length;
    			this.second = (this.second - 1) % this.slides.length;
    			this.third = (this.third - 1) % this.slides.length;
    			this.last = (this.last - 1) % (this.slides.length);
    
    			this.navigationItem.eq(this.first).addClass('active');
    		})
    
    		this.navigationItem.on('click', () => {
    			this.changeSlide($(this).index());
    		})
    
    		this.slides.on('click', () => {
    			if ($(this).hasClass('second') || $(this).hasClass('third')) {
    				this.changeSlide($(this).index());
    			}
    		})
    
    		this.sliderSection.find('.link.show-all').on('click', (e) => {
    			e.preventDefault();
    			this.sliderSection.toggleClass('show-all');
    		})
    	}
    
    	changeSlide(index) {
    		this.first = index;
    		this.second = (this.first + 1) % (this.slides.length);
    		this.third = (this.first + 2) % (this.slides.length);
    		this.last = (this.first - 1) % (this.slides.length);
    
    		this.slides.addClass('motion');
    		this.navigationItem.removeClass('active')
    		setTimeout(() => {
    			this.animationInProgress = false;
    			this.startMotion();
    		}, 500);
    
    		this.navigationItem.eq(this.first).addClass('active');
    	}
    
    	startMotion() {
    		this.slides.removeClass('first second third last');
    		this.slides.eq(this.first).addClass('first');
    		this.slides.eq(this.second).addClass('second');
    		if (this.slider.length > 2) {
    			this.slides.eq(this.third).addClass('third');
    		}
    		this.slides.eq(this.last).addClass('last');
    
    		setTimeout(() => {
    			this.slides.removeClass('motion');
    		},500);
    
    	}
    }
    
    /**
     * Trainings slider script
     */
    class ME_TrainingsSlider {
    	constructor() {
    		this.initState();
    		this.initEvents();
    	}
    
    	initState() {
    		this.sliderWrapper = $('.trainings-slider');
    		this.dots = this.sliderWrapper.find('.dot');
    		this.prevBtn = this.sliderWrapper.find('.prev');
    		this.nextBtn = this.sliderWrapper.find('.next');
    		this.list = this.sliderWrapper.find('.trainings-list');
    		this.items = this.list.find('.trainings-list-item');
    		this.currentItem = 0;
    		this.animationInProgress = false;
    	}
    
    	initEvents() {
    		if (!this.sliderWrapper.length) {
    			return
    		}
    
    		setTimeout(() => {
    			this.showNextSlide();
    		}, 4500);
    
    		this.swipeEffect = new Hammer(this.sliderWrapper[0]);
    
    		this.nextBtn.on('click', e => {
    			e.preventDefault();
    
    			if (e.originalEvent) {
    				this.blankSlide = true;
    			}
    
    			if (this.animationInProgress) {
    				return;
    			}
    
    			this.currentItem++;
    			this.animationInProgress = true;
    
    			if (this.currentItem >= this.items.length) {
    				this.currentItem = 0;
    			}
    
    			this.dots.removeClass('is-active');
    			this.dots.eq(this.currentItem).addClass('is-active');
    			this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
    			setTimeout(() => {
    				this.animationInProgress = false;
    			}, 550);
    		});
    
    		this.prevBtn.on('click', e => {
    			e.preventDefault();
    
    			if (e.originalEvent) {
    				this.blankSlide = true;
    			}
    
    			if (this.animationInProgress) {
    				return;
    			}
    
    			this.currentItem--;
    			this.animationInProgress = true;
    
    			if (this.currentItem < 0) {
    				this.currentItem = this.items.length - 1;
    			}
    
    			this.dots.removeClass('is-active');
    			this.dots.eq(this.currentItem).addClass('is-active');
    			this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
    			setTimeout(() => {
    				this.animationInProgress = false;
    			}, 550);
    		});
    
    		for (let i = 0; i < this.dots.length; i++) {
    			this.dots.eq(i).on('click', e => {
    				e.preventDefault();
    
    				if (e.originalEvent) {
    					this.blankSlide = true;
    				}
    
    				if (this.animationInProgress) {
    					return;
    				}
    
    				this.currentItem = i;
    				this.animationInProgress = true;
    				this.dots.removeClass('is-active');
    				this.dots.eq(this.currentItem).addClass('is-active');
    				this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
    				setTimeout(() => {
    					this.animationInProgress = false;
    				}, 550);
    			});
    		}
    
    		this.swipeEffect.on('swipe', ev => {
    			if (ev.type === 'swipe' && ev.direction === 2) {
    				if (this.currentItem < this.dots.length - 1) {
    					this.currentItem++;
    				} else {
    					this.currentItem = 0;
    				}
    
    				this.dots.eq(this.currentItem).trigger('click');
    			}
    
    			if (ev.type === 'swipe' && ev.direction === 4) {
    				if (this.currentItem > 0) {
    					this.currentItem--;
    				} else {
    					this.currentItem = this.dots.length - 1;
    				}
    
    				this.dots.eq(this.currentItem).trigger('click');
    			}
    		});
    	}
    
    	showNextSlide() {
    		if (this.blankSlide) {
    			this.blankSlide = false;
    		} else {
    			this.nextBtn.trigger('click');
    		}
    
    		setTimeout(() => {
    			this.showNextSlide();
    		}, 5500);
    	}
    }
    
    /**
     * Reviews slider script
     */
    class ME_ReviewsSlider {
    	constructor() {
    		this.initState();
    		this.initEvents();
    	}
    
    	initState() {
    		this.testimonialsListWrapper = $('.training-course-reviews');
    		this.dotsList = this.testimonialsListWrapper.find('.dots');
    		this.dots = this.dotsList.find('.dot');
    		this.list = this.testimonialsListWrapper.find('.training-course-reviews-list');
    		this.items = this.list.find('.training-course-reviews-item');
    		this.currentItem = 0;
    		this.itemsPerPage = 3;
    		this.animationInProgress = false;
    	}
    
    	initEvents() {
    		this.initRWD();
    
    		if (this.testimonialsListWrapper.length) {
    			this.initUI();
    		}
    	}
    
    	initUI() {
    		this.swipeEffect = new Hammer(this.testimonialsListWrapper[0]);
    
    		for (let i = 0; i < this.dots.length; i++) {
    			this.dots.eq(i).on('click', e => {
    				e.preventDefault();
    
    				if (this.animationInProgress) {
    					return;
    				}
    
    				this.currentItem = i;
    				this.animationInProgress = true;
    				this.dots.removeClass('is-active');
    				this.dots.eq(this.currentItem).addClass('is-active');
    				this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
    
    				setTimeout(() => {
    					this.animationInProgress = false;
    				}, 550);
    			});
    		}
    
    		this.swipeEffect.on('swipe', ev => {
    			if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
    				if (this.currentItem < this.items.length - this.itemsPerPage) {
    					this.currentItem++;
    				} else {
    					return
    				}
    
    				this.dots.eq(this.currentItem).trigger('click');
    			}
    
    			if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
    				if (this.currentItem > 0) {
    					this.currentItem--;
    				} else {
    					return
    				}
    
    				this.dots.eq(this.currentItem).trigger('click');
    			}
    		});
    	}
    
    	initRWD() {
    		this.desktopViewport = window.matchMedia('(min-width: 841px)');
    		this.tabletViewport = window.matchMedia('(min-width: 561px) and (max-width: 840px)');
    		this.mobileViewport = window.matchMedia('(max-width: 560px)');
    		if (this.desktopViewport.matches) this.updateViewports('desktop');
    		if (this.tabletViewport.matches) this.updateViewports('tablet');
    		if (this.mobileViewport.matches) this.updateViewports('mobila');
    		this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
    		this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
    		this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
    
    
    		if (this.desktopViewport.matches) {
    			this.itemsPerPage = 3;
    		} else if (this.tabletViewport.matches) {
    			this.itemsPerPage = 2;
    		} else if (this.mobileViewport.matches) {
    			this.itemsPerPage = 1;
    		}
    
    		this.toggleDotsVisibility();
    
    		this.desktopViewport.addListener(mq => {
    			if (mq.matches) {
    				this.setItemsPerPage(3);
    			}
    		});
    
    		this.tabletViewport.addListener(mq => {
    			if (mq.matches) {
    				this.setItemsPerPage(2);
    			}
    		});
    
    		this.mobileViewport.addListener(mq => {
    			if (mq.matches) {
    				this.setItemsPerPage(1);
    			}
    		});
    	}
    
    	updateViewports(type) {
    		if (this.currentViewport !== type) {
    			this.currentItem = 0;
    			this.list.css('margin-left', "0%");
    			this.currentViewport = type;
    		}
    	}
    
    	setItemsPerPage(numberOfItems) {
    		this.currentItem = 0;
    		this.itemsPerPage = numberOfItems;
    		this.dots.removeClass('is-active');
    		this.dots.eq(this.currentItem).addClass('is-active');
    		this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
    		this.toggleDotsVisibility();
    	}
    
    	toggleDotsVisibility() {
    		let visibleDots = this.items.length - this.itemsPerPage;
    
    		for (let i = 0; i < this.dots.length; i++) {
    			let visibilityState = i <= visibleDots ? 'block' : 'none';
    			this.dots.eq(i).css('display', visibilityState);
    		}
    
    		if (this.items.length - this.itemsPerPage <= 0) {
    			this.dotsList.css('display', 'none');
    		} else {
    			this.dotsList.css('display', 'flex');
    		}
    	}
    }
    
    /**
     * Trainings TT slider script
     */
     class ME_SliderTT {
    	constructor() {
    		this.initState();
    		this.initEvents();
    	}
    
    	initState() {
    		this.slider = $('#tt-slider');
    		this.wrapper= $('.tt-slider');
    		this.content = $('.tt-slider-content');
    		this.thumb = $('.tt-thumb');
    		this.image = $('.tt-slider-image');
    		this.slides = $('.tt-slider-slide');
    		this.currentSlide = 1;
    		this.next = $('.tt-slider-next');
    		this.prev = $('.tt-slider-prev');
    		this.animating
    	}
    
    	initEvents() {
    		if (!this.wrapper.length) {
    			return
    		}
    
        this.moveToNewSlide(1, 1)
    
        this.next.on('click', (e) => {
          e.preventDefault()
          this.moveToNewSlide(this.currentSlide, this.currentSlide + 1)
        })
    
        this.prev.on('click', (e) => {
          e.preventDefault()
          this.moveToNewSlide(this.currentSlide, this.currentSlide - 1)
        })
    
        this.wrapper.on('scroll', (e) => {
    			let maxWWidth = this.content.outerWidth() - this.wrapper.outerWidth()
    			let offsetLeft = e.target.scrollLeft;
    			let percent = (100 * offsetLeft) / maxWWidth
    			let imageWidth = this.image.outerWidth()
    			let newSlide = Math.ceil(percent / 100 * this.slides.length);
          let ele = document.getElementById('tt-thumb')
    
          if (this.currentSlide === 1) {
            this.prev.removeClass('active')
          } else {
            this.prev.addClass('active')
          }
    
          if (this.currentSlide === this.slides.length) {
            this.next.removeClass('active')
          } else {
            this.next.addClass('active')
          }
    
          if (newSlide !== this.currentSlide && ele.style.cursor !== 'grabbing' && !this.animating && newSlide > 0 && jQuery(window).outerWidth() > 760) {
            this.moveToNewSlide(this.currentSlide, newSlide);
          }
    
          this.image.css('transform', 'translate(' + (-(percent * (imageWidth - this.content.outerWidth())) / 100) + 'px, 0)')
          this.thumb.css('left', (percent * 0.7) + '%')
    
          this.currentSlide = newSlide > 0 ? newSlide : 1;
          $('.slide-number .current').html(this.currentSlide < 1 ? 1 : this.currentSlide)
        })
    
        if (jQuery(window).outerWidth() <= 760){
          this.slider.on('swipeleft', (e) => {
            e.preventDefault()
            this.moveToNewSlide(this.currentSlide, this.currentSlide + 1)
          })
    
          this.slider.on('swiperight', (e) => {
            e.preventDefault()
            this.moveToNewSlide(this.currentSlide, this.currentSlide - 1)
          })
        }
    
    		document.addEventListener('DOMContentLoaded', () => {
    			const ele = document.getElementById('tt-slider');
    			if (jQuery(window).outerWidth() > 760 && ele) {
    				this.grabToSlide(ele);
    			}
    		});
    
    		document.addEventListener('DOMContentLoaded', () => {
    			const ele = document.getElementById('tt-thumb');
    			if (jQuery(window).outerWidth() > 760 && ele) {
    				this.grabToSlide(ele);
    			}
    		});
    	}
    
    	grabToSlide(ele) {
    		ele.style.cursor = 'grab';
    
    		let pos = {top: 0, left: 0, x: 0, y: 0};
    
    		const mouseDownHandler = (e) => {
    			if (!this.animating) {
    				ele.style.cursor = 'grabbing';
    				ele.style.userSelect = 'none';
    
    				pos = {
    					left: ele.scrollLeft,
    					top: ele.scrollTop,
    					// Get the current mouse position
    					x: e.clientX,
    					y: e.clientY,
    				};
    
    			}
    			document.addEventListener('mousemove', mouseMoveHandler);
    			document.addEventListener('mouseup', mouseUpHandler);
    		};
    
    		const mouseMoveHandler = (e) => {
    			if (!this.animating) {
    				// How far the mouse has been moved
    				const dx = e.clientX - pos.x;
    				const dy = e.clientY - pos.y;
    
    				// Scroll the element
    				ele.scrollTop = pos.top - dy;
    				ele.scrollLeft = pos.left - dx;
    			}
    		};
    
    		const mouseUpHandler = () => {
    			if (!this.animating) {
    				ele.style.cursor = 'grab';
    				ele.style.removeProperty('user-select');
    			}
    			document.removeEventListener('mousemove', mouseMoveHandler);
    			document.removeEventListener('mouseup', mouseUpHandler);
    		};
    
    		// Attach the handler
    		ele.addEventListener('mousedown', mouseDownHandler);
    	}
    
    	moveToNewSlide(slide, newSlide) {
    		this.animating = true;
    		let nextSlide = this.slides.eq(newSlide > slide ? slide : (newSlide - 1));
    		let newSlidePosition = nextSlide.position().left + (nextSlide.outerWidth()/2) - ($(window).outerWidth()/2)
    	
    		this.slider.animate({scrollLeft: newSlidePosition}, 800);
    		setTimeout(() => {
    			this.animating = false;
    		}, 800)
    	};	
    }
    
    /**
     * Product page elements
     */
    class ME_Product {
        constructor() {
            this.initOpenExpandableProductContent();
            this.initOpenExpandableProductList();
            this.initOpenMaterialTools();
            this.initPricesShowMore();
            this.initTeacherShowMore();
            this.initProductPanelLevel();
            this.initProductNavigation();
            this.initProductGallery();
        }
    
        initOpenExpandableProductContent() {
            let btnExpandalbe = $('.product-content-sections-wrapper__button');
            let productContentExpandable = $('.product-content-sections-wrapper--expandable');
    
            if (!btnExpandalbe.length) {
                return;
            }
    
            btnExpandalbe.on('click', e => {
                e.preventDefault()
                productContentExpandable.addClass('active');
                $(this).closest('#main').find('.hide-description-section').removeClass('hidden');
                $(this).remove();
            })
        }
    
        initOpenExpandableProductList() {
            let btnExpandableList = $('.product-default__show-more');
    
            if (!btnExpandableList.length) {
                return;
            }
    
            btnExpandableList.on('click', (e) => {
                e.preventDefault();
                $(e.target).parents('.product-default-component__content').find('.product-expandable-list').addClass('active');
                $(e.target).remove();
            })
        }
    
        initOpenMaterialTools() {
            let btnOpenMaterialTools = $('.product-material-tools__table__show-more-trigger');
    
            if (!btnOpenMaterialTools.length) {
                return;
            }
    
            btnOpenMaterialTools.on('click', (e) => {
                e.preventDefault();
                $(e.target).prev('.product-material-tools__table').addClass('active');
                $(e.target).remove();
            });
        }
    
        initPricesShowMore() {
            let btnProductConponentsShowMore = $('.product-components__show-more');
    
            if (!btnProductConponentsShowMore.length) {
                return;
            }
    
            btnProductConponentsShowMore.on('click', (e) => {
                e.preventDefault();
                $('.product-components__table').addClass('active');
                $(e.target).remove();
    
                setTimeout(() => {
                    $('.product-components__table').addClass('visible')
                })
            })
        }
    
        initPricesShowMore() {
            let btnPricesShowMore = $('.product-prices__show-more');
    
            if (!btnPricesShowMore.length) {
                return;
            }
    
            btnPricesShowMore.on('click', (e) => {
                e.preventDefault();
                $('.product-prices').addClass('active');
                $(e.target).remove();
            })
        }
    
        initTeacherShowMore() {
            let btnTeacherShowMore = $('.product-teacher__show-more');
    
            if (!btnTeacherShowMore.length) {
                return;
            }
    
            btnTeacherShowMore.on('click', (e) => {
                e.preventDefault();
                $(e.target).parent().addClass('active');
                $(e.target).remove();
            })
        }
    
        initProductPanelLevel() {
            $('ul.product-panel__levels li').click((e) => {
                let level_index = $(e.target).data('level');
    
                $('ul.product-panel__levels li').removeClass('active');
                $('ul.product-panel__levels li[data-level="' + level_index + '"]').addClass('active');
    
                $('.level-p').addClass('hidden');
                $('.level-p.level-p-' + level_index).removeClass('hidden');
    
                $('.row_level').addClass('hidden');
                $('.row_level_' + (level_index)).removeClass('hidden');
    
            });
        }
    
        initProductNavigation() {
            let nav = $('.section-product-navigation');
            let navWrapper = $('.product-navigation-wrapper');
            let header = $('#top');
            let navItems = nav.find('.product-navigation__list');
    
            $(window).on('scroll', () => {
                let headerPosition = $(window).scrollTop();
    
                $('.product-navigation-section').each(function () {
                    if (headerPosition > $(this).offset().top - 250 && headerPosition < $(this).offset().top + $(this).outerHeight()) {
                        var activeItem = navItems.find('a[href="#' + $(this).attr('id') + '"]').parent()
                        activeItem.addClass('active')
                        activeItem.siblings().removeClass('active')
                    }
                })
            })
    
            $(window).on('load', () => {
                setTimeout(() => {
                    $(window).scroll()
                }, 250)
            })
    
            // Open mobile nav list
            $('.product-navigation__list-open').on('click', (e) => {
                e.preventDefault();
                let navItemsLi = navItems.find('.product-navigation__item');
                nav.toggleClass('open-mobile-nav');
    
                for (let i = 0; i < navItemsLi.length; i++) {
                    navItemsLi.removeClass('active');
                }
            });
    
            // Close mobile nav list
            $("body").on('click', function () {
                nav.removeClass('open-mobile-nav');
            });
    
            $(".section-product-navigation").on('click', function (e) {
                e.stopPropagation();
            });
    
            $('.product-navigation__list-close').on('click', function (e) {
                e.preventDefault();
                nav.removeClass('open-mobile-nav');
            });
    
            // Product Scroll
            $('.product-scroll').on('click', (e) => {
                e.preventDefault();
                let link = $(e.target);
                let el = $(link.attr('href'));
                let navTopStyle = navWrapper.css('top');
                let navTopStylePosition = parseInt(navTopStyle.substring(0, navTopStyle.length - 1))
                let top = el.offset().top - navTopStylePosition - 120;
                nav.removeClass('open-mobile-nav');
            });
        }
    
        initProductGallery () {
            $('.product-panel__gallery__thumbnail--image').on('click', function (e) {
                e.preventDefault()
                $(this).siblings().removeClass('active');
                $(this).addClass('active');
                let imageNumber = $(this).attr('data-product-thumbnail');
    
                $('.product-panel__gallery__image').css('transform', 'translate(-' + imageNumber*100 + '%, 0)' );
            });
        }
    }
    
    /**
     * Forms elements
     */
    class ME_Forms {
     constructor() {
      this.initPostCode();
      this.initHelpForm();
      this.initHelpTiles();
      this.initFixedLoginBox();
      this.checkRegisterForm();
     }
    
     initPostCode() {
    
      let unmaskedFields = $('.product-advisor__contact__fieldset.product-advisor__contact__post-code').find('[name*="post_code"], [name*="postcode"]');
    
      if (unmaskedFields.length) {
       unmaskedFields.attr('data-unmasked', 'true');
    
       unmaskedFields.keyup(function () {
        if (this.value.length == this.maxLength) {
         if ($(this).nextAll('input').length) {
          $(this).nextAll('input').eq(0).focus();
         }
        }
       });
      }
    
      $('[name*="post_code"], [name*="postcode"]').not('[data-unmasked="true"]').mask('00-000');
     }
    
     initHelpForm() {
      let helpPage = $('section.section-help');
      let loginBox = helpPage.find('.login-box');
      let loginBoxForm = loginBox.find('#userForm');
      let mobileHelpBottom = $('.mobile-help-bottom-sticky');
      let hideLoginBox = loginBox.find('.hide-form');
      let hideBtnLoginBox = loginBox.find('.hide-mobile-bottom');
      let steps = loginBoxForm.find('ul.help-form-steps li');
      let stepsList = loginBoxForm.find('ul.help-steps-list li');
      let backToForm = $('.show-form');
      let attachments = 0;
    
      if (mobileHelpBottom.length > 0) {
       $('footer').addClass('help-footer');
      }
    
      steps.find('.input').on('input', function () {
       $(this).removeClass('error')
      })
    
      steps.eq(0).find('button').on('click', function (e) {
       e.preventDefault();
    
       steps.eq(0).find('.required').each(function () {
        let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        let inputType = $(this).attr('type');
    
        if (inputType === 'email') {
         if (!emailPattern.test($(this).val())) {
          $(this).addClass('error');
         } else {
          $(this).removeClass('error');
         }
        } else if (inputType === 'text') {
         if ($(this).val().length <= 0) {
          $(this).addClass('error');
         } else {
          $(this).removeClass('error');
         }
        }
       });
    
       if (steps.eq(0).find('.required.error').length <= 0) {
        steps.eq(0).removeClass('active')
        stepsList.eq(0).addClass('complete')
        steps.eq(1).addClass('active')
        stepsList.eq(1).addClass('active')
       }
      })
    
      steps.eq(1).find('button').on('click', function (e) {
       e.preventDefault();
    
       if ($(window).outerWidth() < 760) {
        steps.eq(0).find('button').click();
       };
    
       steps.eq(1).find('.required').each(function () {
        if ($(this).val().length <= 0) {
         $(this).addClass('error')
        } else {
         $(this).removeClass('error')
        }
       });
    
       if (steps.eq(1).find('.required.error').length <= 0) {
        $(this).addClass('disabled')
        $(this).addClass('isLoading')
       }
      })
    
      $('.add-attachment').on('click', function (e) {
       e.preventDefault();
       $('.attachment').eq(attachments).fadeIn();
       attachments++
       if (attachments > 3) {
        $('.add-attachment-row').fadeOut()
       }
      })
    
      mobileHelpBottom.on('click', function (e) {
       e.preventDefault();
       mobileHelpBottom.addClass('is-hidden');
       loginBox.addClass('active');
      });
    
      hideLoginBox.on('click', (e) => {
       e.preventDefault();
       mobileHelpBottom.removeClass('is-hidden')
       loginBox.removeClass('active')
      })
    
      hideBtnLoginBox.on('click', (e) => {
       e.preventDefault();
       mobileHelpBottom.removeClass('is-hidden')
       loginBox.removeClass('active')
      })
    
      backToForm.on('click', () => {
       location.reload();
      })
     }
    
     initHelpTiles() {
      let helpTiles = $('section.help-tiles');
    
      if (!helpTiles.length) {
       return
      }
    
      let searchWrapper = helpTiles.find('.help-search-wrapper');
      let searchInput = searchWrapper.find('.input.search');
      let searchItems = helpTiles.find('.tile .tile__content h3');
    
      searchInput.on('input', function () {
       let value = $(this).val()
    
       if (value.length > 0) {
        searchItems.each(function () {
         var item = $(this)
    
         if (item.text().toLowerCase().indexOf(value.toLowerCase()) >= 0) {
          item.closest('.tile').css('display', 'flex')
         } else {
          item.closest('.tile').css('display', 'none')
         }
        })
       } else {
        $('section.help-tiles .help-content .tiles .tile').css('display', 'flex')
       }
      });
     }
    
     initFixedLoginBox() {
      let helpPage = $('section.section-help');
      let loginBox = helpPage.find('.login-box');
    
      if (!loginBox.length) {
       return
      }
    
      $(window).on('scroll', () => {
       let positionY = $(window).scrollTop();
    
       if (positionY > 25 && !loginBox.hasClass('is-fixed')) {
        loginBox.addClass('is-fixed');
        return;
       }
    
       if (positionY <= 25 && loginBox.hasClass('is-fixed')) {
        loginBox.removeClass('is-fixed');
       }
      });
     }
    
     checkRegisterForm() {
      let conferenceForm = document.querySelector('.form_register_conference');
      if (!conferenceForm) {
       return
      }
      let conferenceFormContainer = conferenceForm.querySelector('.form');
      let currentHideInput = conferenceFormContainer.querySelector('input#sector-9');
      let otherInput = conferenceFormContainer.querySelectorAll('input');
    
      if (currentHideInput.checked) {
       document.querySelector('.books-form').classList.add('hidden');
       document.querySelector('.school-data').classList.add('hidden');
      } else {
       document.querySelector('.books-form').classList.remove('hidden');
       document.querySelector('.school-data').classList.remove('hidden');
      }
    
      for (let i = 0; i < otherInput.length; i++) {
       otherInput[i].addEventListener('change', function () {
        setTimeout(function () {
         if (currentHideInput.checked) {
          document.querySelector('.books-form').classList.add('hidden');
          document.querySelector('.school-data').classList.add('hidden');
         } else {
          document.querySelector('.books-form').classList.remove('hidden');
          document.querySelector('.school-data').classList.remove('hidden');
         }
        }, 100)
       })
      }
     }
    }
    
    /**
     * Quizlet script
     */
    class ME_Quizlet {
        constructor() {
            this.initState();
            this.initEvents();
        }
    
        initState() {
            this.quizletFaqSection = $('.js-quizlet-tabs');
            this.tablinksWrapper = this.quizletFaqSection.find('.tablinks-wrapper');
            this.tabcontentWrapper = this.quizletFaqSection.find('.tabcontent-wrapper');
            this.tabs = this.tablinksWrapper.find('.tablinks');
            this.contents = this.tabcontentWrapper.find('.tabcontent');
            this.animationInProgress = false;
        }
    
        initEvents() {
            let self = this;
    
            for (let i = 0; i < this.tabs.length; i++) {
                this.tabs.eq(i).on('click', () => {
                    self.tabs.removeClass('active');
                    self.tabs.eq(i).addClass('active');
                    self.contents.removeClass('active');
                    self.contents.eq(i).addClass('active');
                    this.animationInProgress = true;
                });
            }
        }
    }
    
    
    jQuery(document).ready(function ($) {
        var rs = [];
        var rsIndex = 0;
    
        var rsConfig = {
            'nav': false,
            'prevnext': false
        };
    
        // glowny kod slidera
        $('.auto-slider').each(function () {
            var container = $(this);
            var autoSlide = true;
            var enableSlide = true;
            var lastSlideActive = container.hasClass('lastSlideActive')
    
            rsIndex += 1;
            rs[rsIndex] = {};
    
            var slider = rs[rsIndex];
    
            slider.container = container;
            slider.currentItem = 0;
    
            if (container.children('ul.slider').children('li').length > 1) {
                if (container.hasClass('prevnext')) {
                    rsConfig.prevnext = true;
                }
    
                if (container.hasClass('nav')) {
                    rsConfig.nav = true;
                }
    
                if (container.hasClass('auto-slide')) {
                    autoSlide = true;
                }
    
                if (rsConfig.prevnext && slider.container.find('.prev').length < 1) {
                    slider.container.append('<div class="prev"><span>&lsaquo;</span></div>');
                    slider.container.append('<div class="next"><span>&rsaquo;</span></div>');
                }
    
                var slideChanged = false;
                var total = slider.container.children('ul').first().children('li').length;
    
                slider.container.find('.next').on('click', function () {
                    goNext();
                    slideChanged = true;
                });
    
                slider.container.on("swipeleft", function (event) { goNext(); });
    
                slider.container.find('.prev').on('click', function () {
                    goBack();
                    slideChanged = true;
                });
    
                slider.container.on("swiperight", function (event) { goBack(); });
    
                function goNext() {
                    slider.currentItem += 1;
    
                    if (slider.currentItem >= total) {
                        slider.currentItem = 0;
                        //return false;
                    }
    
                    if (rsConfig.nav) {
                        console.log(slider.currentItem)
                        slider.container.find('ul.nav').find('li').removeClass('active');
                        slider.container.find('ul.nav').find('li').eq(slider.currentItem).addClass('active');
                    }
                    slider.container.children('ul').first().children('li').css('transform', 'translateX(' + (- (slider.currentItem * 100) + '%') + ')');
                }
    
                function goBack() {
                    slider.currentItem -= 1;
    
                    if (slider.currentItem < 0) {
                        slider.currentItem = total - 1;
                        //  return false;
                    }
    
                    if (rsConfig.nav) {
                        slider.container.find('ul.nav').find('li').removeClass('active');
                        slider.container.find('ul.nav').find('li').eq(slider.currentItem).addClass('active');
                    }
                    slider.container.children('ul').first().children('li').css('transform', 'translateX(' + (- (slider.currentItem * 100) + '%') + ')');
                }
    
                slider.container.mouseenter(function () {
                    enableSlide = false;
                });
                slider.container.mouseleave(function () {
                    enableSlide = true;
                });
                var progress = 0;
    
                if (autoSlide === true) {
                    console.log('autoslide');
                    console.log('-----');
                    setInterval(function () {
                        if (enableSlide) {
                            if (rsConfig.nav) {
                                slider.container.find('ul.nav').find('li.active').find('.progress span').css('width', (progress / 7) + '%');
                                progress += 10;
                            }
                            if (progress > 700) {
                                progress = 0;
                                if (rsConfig.nav) {
                                    slider.container.find('ul.nav').find('span').css('width', '0');
                                }
                                goNext();
                            }
                        }
    
                        if (slideChanged) {
                            progress = 0;
                            slideChanged = false;
                            if (rsConfig.nav) {
                                slider.container.find('ul.nav').find('span').css('width', '0');
                            }
                        }
                    }, 1500);
                }
    
                slider.container.children('ul').first().children('li').each(function () {
                    //slider.container.find('ul.nav').append('<li></li>');
                    slider.currentItem++;
                });
                slider.currentItem = 0;
    
                if (rsConfig.nav) {
                    slider.container.find('ul.nav').find('li').first().addClass('active');
    
                    slider.container.find('ul.nav').find('li').on('click', function () {
                        slideChanged = true;
                        var index = $(this).index();
    
                        slider.container.find('ul.nav').find('li').removeClass('active');
                        slider.container.find('ul.nav').find('li').eq(index).addClass('active');
    
                        slider.currentItem = index;
                        slider.container.children('ul').first().children('li').css('transform', 'translateX(' + (-(slider.currentItem * 100) + '%') + ')');
                    });
                }
    
                if (lastSlideActive) {
                    slideChanged = true;
                    var index = container.children('ul.slider').children('li').length - 1
    
                    if (rsConfig.nav) {
                        slider.container.find('ul.nav').find('li').removeClass('active');
                        slider.container.find('ul.nav').find('li').eq(index).addClass('active');
                    }
    
                    slider.currentItem = index;
                    slider.container.children('ul').first().children('li').css('transform', 'translateX(' + (-(slider.currentItem * 100) + '%') + ')');
                }
    
    
                if (slider.container.closest('.tt-unregister-slider').length < 1) {
    
                    $(window).on("resize load", function () {
                        // Set .right's width to the window width minus 480 pixels
                        var total = slider.container.children('ul').first().children('li').length;
                        var window_width = $(window).width();
                        if (window_width > 1024 && slider.container.hasClass('start-2') && total < 3) {
                            slider.container.find('.prev, .next').css('display', 'none');
                        }
                        else if (window_width <= 1024 && window_width > 900 && total < 4) {
                            slider.container.find('.prev, .next').css('display', 'none');
                        }
                        else if (window_width <= 900 && window_width > 650 && total < 3) {
                            slider.container.find('.prev, .next').css('display', 'none');
                        }
                        else if (window_width < 650 && total < 2) {
                            slider.container.find('.prev, .next').css('display', 'none');
                        }
                        else {
                            slider.container.find('.prev, .next').css('display', 'block');
                        }
                        // Invoke the resize event immediately
    
                        var max_height = 0;
                        var this_height = 0;
    
                        container.children('ul.slider').children('li').each(function () {
                            var this_height = $(this).find('.left').outerHeight();
                            if (this_height > max_height) {
                                max_height = this_height;
                            }
                        });
    
                        container.children('ul.slider').children('li').css('height', max_height);
    
                    }).resize();
                }
            }
        });
    });
    
    /**
     * Login script
     */
    class ME_BTSFormRegister {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.btsRegister = $('.back-to-school.register');
            this.btsRegisterForm = this.btsRegister.find('form.form');
            this.submitRegisterForm = this.btsRegisterForm.find('#register-button');
    
            if (!this.btsRegister.length) {
                return
            }
    
            this.initEvents();
        }
    
        initEvents() {
            let formHelper = new ME_FormHelper(this.btsRegisterForm);
    
            $('[data-answer-id]').parents('select').on('change', function (e) {
                $(this).find('option[data-answer-id]').each(function () {
                    let id = $(this).attr('data-answer-id');
                    $('[data-dependency-answer-id="' + id + '"]').addClass("is-hidden");
                });
    
                let selectedOption = $(this).find('option:selected');
                let answerId = selectedOption.attr('data-answer-id');
                if (answerId) {
                    $('[data-dependency-answer-id="' + answerId + '"]').removeClass("is-hidden");
                }
            });
    
            $('[data-answer-id]').on('input change', function (e) {
                let $target = $(e.target);
                let answerId = $target.attr('data-answer-id');
                let shouldBeVisible = false;
    
                if ($target.is('input[type="checkbox"]')) {
                    shouldBeVisible = $target.is(':checked');
                } else if ($target.is('input[type="radio"]')) {
                    let radioName = $target.attr('name');
    
                    $('input[type="radio"][name="' + radioName + '"]').each((i, el) => {
                        let id = $(el).attr('data-answer-id');
                        $('[data-dependency-answer-id="' + id + '"]').addClass("is-hidden");
                    });
    
                    shouldBeVisible = $target.is(':checked');
                }
    
                if (shouldBeVisible) {
                    $('[data-dependency-answer-id="' + answerId + '"]').removeClass("is-hidden");
                } else {
                    $('[data-dependency-answer-id="' + answerId + '"]').addClass("is-hidden");
                }
            });
    
            this.submitRegisterForm.on('click', e => {
                e.preventDefault();
                let result = formHelper.formValidate();
                var books_required = true;
    
                if ($('input[name="sectors[]"]:checked').length == 0) {
                    let validationError = $('.sectors-header').find('.validation-error');
                    validationError.removeClass('is-hidden');
                    validationError.text('Pole jest wymagane');
                } else {
                    $('input[name="sectors[]"]:checked').each(function () {
                        if ($(this).val() == 9) {
                            books_required = false;
                        }
                    });
                }
    
                if (books_required && $('select[name="books[]"] option:selected').length == 0) {
                    let validationError = $('.books-header').find('.validation-error');
                    validationError.removeClass('is-hidden');
                    validationError.text('Pole jest wymagane');
                } else {
                    let validationError = $('.books-header').find('.validation-error');
                    validationError.addClass('is-hidden');
                    validationError.text('');
                }
    
                if (result) {
                    if ($('.form-item.required-check .checkbox--radio:first-child input').is(':checked')) {
                        let dataHideAnswer = document.querySelectorAll('.form-item[data-dependency-answer-id]');
                        let allDivsHaveCheckedRadio = true;
    
                        dataHideAnswer.forEach(item => {
                            let inputs = item.querySelectorAll('input');
                            let isAnyRadioButtonChecked = false;
    
                            inputs.forEach(function (radioButton) {
                                if (radioButton.checked) {
                                    isAnyRadioButtonChecked = true;
                                }
                            });
    
                            if (!isAnyRadioButtonChecked) {
                                allDivsHaveCheckedRadio = false;
                                let validationError = item.querySelector('.validation-error');
                                validationError.classList.remove('is-hidden');
                                validationError.textContent = 'Pole jest wymagane';
                            }
    
                            inputs.forEach(input => {
                                input.addEventListener('click', function () {
                                    let validationError = item.querySelector('.validation-error');
                                    validationError.classList.add('is-hidden');
                                    validationError.textContent = '';
                                })
                            });
                        })
    
                        if (allDivsHaveCheckedRadio) {
                            this.btsRegisterForm.submit()
                        }
                    } else {
                        this.btsRegisterForm.submit()
                    }
                } else {
                    let firstValidationError = $('.validation-error').not('.is-hidden').first();
    
                    if (firstValidationError.length) {
                        $('html, body').animate({
                            scrollTop: firstValidationError.offset().top - 170
                        }, 1000);
                    }
                }
            });
        }
    }
    
    /*
     * Tabs script
     */
    class ME_Tabs {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.currentIndex = 0;
            this.win = jQuery(window);
            this.wrapper = $('.js-tabs');
            this.tabs = this.wrapper.find('.js-tablinks-wrapper .js-tablinks');
            this.contents = this.wrapper.find('.js-tabcontent-wrapper .js-tabcontent');
            this.animationInProgress = false;
    
            if (this.tabs.length) {
                this.initTabsEvents();
            }
        }
    
        initTabsEvents() {
            for (let i = 0; i < this.tabs.length; i++) {
                this.tabs.eq(i).on('click', () => {
                    this.tabs.removeClass('active');
                    this.tabs.eq(i).addClass('active');
                    this.contents.removeClass('active');
                    this.contents.eq(i).addClass('active');
                    this.animationInProgress = true;
                });
            }
        }
    }
    
    /**
     * Repro script
     */
    class ME_RepoForm {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.repoForm = $('form.repo-form');
            this.submitRepoFormBtn = this.repoForm.find('.repo-form-submit');
    
            if (!this.repoForm.length) {
                return
            }
    
            this.initEvents();
        }
    
        initEvents() {
            let formHelper = new ME_FormHelper(this.repoForm);
            this.submitRepoFormBtn.addClass('is-loading');
    
            this.submitRepoFormBtn.on('click', e => {
                e.preventDefault();
                let result = formHelper.formValidate();
    
                if (result) {
                    this.runRecaptchaCheck();
                }
            });
        }
    
        runRecaptchaCheck () {
            let inputField = this.repoForm.find('[name="g-recaptcha-response"]');
            let recaptchaKey = this.repoForm.attr('data-recaptcha-site-key');
            let recaptchaValidationInfo = this.repoForm.find('.recaptcha-validation')
    
            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaKey).then(function(token) {
                    inputField.val(token)
                    inputField.addClass('success');
                    $('form.repo-form').submit()
                }).catch(function () {
                    inputField.addClass('error');
                    recaptchaValidationInfo.removeClass('is-hidden');
                });
            });
        }
    }
    
    /**
     * Form steps Circle script
     */
    class ME_StepsCircleForm {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.stepsCircleForm = $('.js-form-steps-circle');
    
            if (!this.stepsCircleForm || !this.stepsCircleForm.length) {
                return
            }
    
            this.btnNext = this.stepsCircleForm.find('.next-step');
            this.btnPrev = this.stepsCircleForm.find('.prev-step');
            this.steps = this.stepsCircleForm.find('.step');
            this.inputBook = this.stepsCircleForm.find('.step-1').find('.input.book');
            this.submitBtn = this.stepsCircleForm.find('.submit-form-btn');
            this.currentStep = 1;
            this.initEvents();
        }
    
        initEvents() {
            for (let i = 0; i < this.inputBook.length; i++) {
                this.inputBook.eq(i).on('input', e => {
                    let value = parseInt(e.target.value, 10);
    
                    if (value === 0) {
                        $('.activator strong').text('Wybierz podręcznik, z którego zamierzasz skorzystać');
                        $('.step-1 .validation-error').text('Wpisz deklarowaną wartość chociaż dla jednego podręcznika');
                    } else if (value >= 1) {
                        $('.activator strong').text('Dodaj kolejny podręcznik, z którego zamierzasz korzystać');
                        $('.step-1 .validation-error').text('');
                    }
                });
            }
    
            this.btnNext.on('click', (e) => {
                e.preventDefault();
                if (this.currentStep === 1) {
                    // let formHelper = new ME_FormHelper(this.stepsCircleForm.find('.step-1'));
                    // let resultStep1 = formHelper.formValidate();
                    let step1 = document.querySelector('.step-1');
    
                    if (step1.querySelectorAll('.input.book').length > 0) {
                        step1.querySelectorAll('.input.book').forEach(input => {
    
                            input.addEventListener('click', function () {
                                step1.querySelector('.validation-error').innerHTML = '';
                            })
    
                            if (input.value === "" || input.value === undefined || input.value <= "0" || input.value === null) {
                                this.currentStep = 1;
                                step1.querySelector('.validation-error').innerHTML = 'Wpisz deklarowaną wartość chociaż dla jednego podręcznika';
                            } else {
                                this.currentStep++;
                                let stepbar = $('body').find('.steps.with-circle-number');
                                stepbar.find('.stepbar-2').addClass('active');
                                step1.querySelector('.validation-error').innerHTML = '';
                                $('.step-1').removeClass('active');
                                $('.step-2').addClass('active');
                            }
                        })
                    } else {
                        this.currentStep++;
                        let stepbar = $('body').find('.steps.with-circle-number');
                        stepbar.find('.stepbar-2').addClass('active');
                        step1.querySelector('.validation-error').innerHTML = '';
                        $('.step-1').removeClass('active');
                        $('.step-2').addClass('active');
                    }
    
                    // if (resultStep1) {
                    //     setTimeout(() => {
                    //         step1.querySelector('.validation-error').classList.remove('hidden')
                    //         step1.querySelector('.validation-error').innerHTML = 'Wpisz deklarowaną wartość chociaż dla jednego podręcznika';
                    //     }, 1000);
    
                    //     step1.querySelectorAll('.input.book').forEach(input => {
    
                    //         input.addEventListener('click', function () {
                    //             step1.querySelector('.validation-error').innerHTML = '';
                    //         })
    
                    //         if (input.value === "" || input.value === undefined || input.value <= "0" || input.value === null) {
                    //             this.currentStep = 1;
                    //             step1.querySelector('.validation-error').innerHTML = 'Wpisz deklarowaną wartość chociaż dla jednego podręcznika';
                    //         } else {
                    //             this.currentStep++;
                    //              let stepbar = $('body').find('.steps.with-circle-number');
                                    // stepbar.find('.stepbar-2').addClass('active');
                                    // $('.step-1').removeClass('active');
                                    // $('.step-2').addClass('active');
                    //         }
                    //     })
                    // }
                    if (document.querySelector('.js-form-steps-circle').querySelectorAll('.effect input').length > 0) {
                        document.querySelector('.js-form-steps-circle').querySelectorAll('.effect input').forEach(input => {
                            if (input.value === 0 || input.value === "" || input.value === null) {
                                input.classList.remove('focus');
                            } else {
                                input.classList.add('focus');
                            }
                        })
                    }
                }
    
                // if (this.currentStep === 2) {
                //     let formHelper = new ME_FormHelper(this.stepsCircleForm.find('.step-2'));
                //     let resultStep2 = formHelper.formValidate();
    
                //     if (resultStep2) {
                //         this.currentStep++;
                //         this.displayStep(this.currentStep)
                //     }
                // }
            });
    
            this.btnPrev.on('click', (e) => {
                e.preventDefault();
    
                this.currentStep = 1;
                let stepbar = $('body').find('.steps.with-circle-number');
                let step1 = $('.step-1');
                stepbar.find('.stepbar-2').removeClass('active');
                this.steps.removeClass('active');
                step1.addClass('active');
                setTimeout(() => {
    				step1.find('.validation-error').html();
    			}, 0);
    
                if (document.querySelector('.js-form-steps-circle').querySelectorAll('.effect input').length > 0) {
                    document.querySelector('.js-form-steps-circle').querySelectorAll('.effect input').forEach(input => {
                        if (input.value === 0 || input.value === "" || input.value === null) {
                            input.classList.remove('focus');
                        } else {
                            input.classList.add('focus');
                        }
                    })
                }
            });
    
            this.submitBtn.on('click', (e) => {
                e.preventDefault();
                let formHelper = new ME_FormHelper(this.stepsCircleForm.find('.step-final'));
                let finalStep = formHelper.formValidate();
    
    
                if (!finalStep) {
                    window.scrollBy({
                        top: (-(this.stepsCircleForm.find('.step-final').offset().top / 2) - 100),
                        behavior: 'smooth'
                    })
                }
    
                if (finalStep) {
                    this.stepsCircleForm.submit()
                }
            });
        }
    }
    
    /*
     * Tabs script
     */
    class ME_Accordions {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.accordions = $('.accordion');
            this.current_tab = this.accordions.find('.current-tab');
            if (this.accordions.length) {
                this.initAccordionsEvents();
            }
        }
    
        initAccordionsEvents() {
            this.accordions.each(function(element){
               let accordion_container = $(this);
               let items = accordion_container.find('.accordion-item');
               items.on('click', function(){
                  let data_number = $(this).data('number');
                  let content_item = $('.accordion-content[data-number="'+data_number+'"]');
                  if(content_item.length > 0){
                      items.removeClass('active');
                      $(this).addClass('active');
                      accordion_container.find('.accordion-content').removeClass('active');
                      content_item.addClass('active');
    
                      if(accordion_container.find('.current-tab').length > 0){
                          accordion_container.find('.current-tab').text($(this).text());
                      }
                      if(accordion_container.find('.categories').length > 0){
                          accordion_container.find('.categories').removeClass('active');
                      }
                  }
               });
            });
    
            if(this.current_tab.length > 0){
                this.current_tab.each(function(element){
                   $(this).on('click', function(){
                    $(this).parent().find('.categories').addClass('active');
                   });
                });
            }
        }
    }
    
    /*
     * Tabs script
     */
    class ME_Submenu {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.submenus = $('.submenu');
            if (this.submenus.length) {
                this.initSubmenusEvents();
            }
        }
    
        initSubmenusEvents() {
            $('.submenu ul.menu').each(function () {
                var active = $(this).children('li.active').length > 0 ? $(this).children('li.active a').html() : $(this).children('li').eq(0).find('a').html();
                $(this).before("<div class='current-tab'>" + active + "</div>");
            });
    
            $('.submenu ul.menu li').click(function () {
                $(this).parent('ul.menu').prev('.current-tab').html($(this).find('a').html());
                $(this).parent('ul.menu').removeClass('active');
            });
    
            $('.submenu .current-tab').click(function () {
                $(this).next('ul.menu').toggleClass('active');
            });
        }
    }
    
    class ME_AddClass {
     constructor() {
      this.addClass();
     }
    
     addClass() {
      let buttonAddClasses = $('.add-new-classes');
      let editButtonClasses = $('.editClass');
      let formContainer = $('#classes-form');
      let hideNewClass = formContainer.find('.school.new');
      if (!buttonAddClasses || !formContainer || !editButtonClasses) {
       return
      }
    
      buttonAddClasses.on('click', function (event) {
       event.preventDefault();
       formContainer.removeClass('hidden');
       buttonAddClasses.addClass('hidden');
    
       $('html').animate({
        scrollTop: ($('#classes-form').offset().top - 150),
       }, 1000);
      })
    
      editButtonClasses.on('click', function (event) {
       event.preventDefault();
       formContainer.removeClass('hidden');
       buttonAddClasses.addClass('hidden');
       hideNewClass.addClass('hidden');
    
       $('html').animate({
        scrollTop: ($('#classes-form').offset().top - 150)
       }, 1000);
      })
     }
    }
    
    class MC_TabsSchool {
     constructor() {
      this.TabsSchool();
      this.scroolMenuFixed();
      this.filterBook();
     }
    
     TabsSchool() {
      let segmentButton = document.querySelectorAll('.segment-button');
      let segment = document.querySelectorAll('.segment');
      let inputMobile = document.querySelector('.input-mobile');
      let categories = document.querySelector('.categories');
      if (!segmentButton || !segment || !inputMobile || !categories) {
       return;
      }
    
      for (let i = 0; i < segmentButton.length; i++) {
       segmentButton.forEach((link) => {
        link.addEventListener('click', function () {
         let href = link.getAttribute('data-segment-id');
         let offsetTop = categories.getBoundingClientRect().top;
         let btsBannerHeight = document.querySelector('.bts-banner-2021').getBoundingClientRect().height
         let positionStop = document.querySelector('#header').getBoundingClientRect().height;
         let scrollTopPosition = (window.scrollY - btsBannerHeight - positionStop);
         let scrollPosition = offsetTop - positionStop;
         if(document.querySelector('.bts-menu').getBoundingClientRect().bottom <= 183) {
          window.scrollBy({
           top: (-scrollTopPosition),
           behavior: 'smooth',
          })
         } else {
          window.scrollBy({
           top: scrollPosition,
           behavior: 'smooth',
          })
         }
    
         segmentButton.forEach(element => {
          element.classList.remove('active');
          element.classList.add('not-active');
         })
    
         segment.forEach(section => {
          section.classList.remove('active');
         })
    
         document.querySelector(`.segment-button[data-segment-id="${href}"]`).classList.add('active');
         document.querySelector(`.segment-button[data-segment-id="${href}"]`).classList.remove('not-active');
         document.querySelector(`.segment-${href}`).classList.add('active');
    
         categories.classList.remove('active');
         let text_item = document.querySelector(`.segment-button[data-segment-id="${href}"]`).querySelector('.segment-button__text').innerHTML;
         inputMobile.innerHTML = text_item;
        })
       })
      }
    
      inputMobile.addEventListener('click', function (e) {
       e.preventDefault();
       categories.classList.toggle('active');
      })
     }
    
     scroolMenuFixed() {
      $(window).on('scroll', function () {
       var offset = $(window).scrollTop();
       var banner_big = $('.bts-banner-2021').outerHeight();
       var menu_header = $('#header').outerHeight();
       var positionOffSet = banner_big + menu_header;
       var page_menu = $('.bts-menu');
       if (offset > (positionOffSet + 250)) {
        page_menu.addClass('sticky');
        page_menu.css('top', `${menu_header}px`);
       }
       else {
        page_menu.removeClass('sticky');
        page_menu.css('top', 'initial');
       }
      }).scroll();
     }
    
     filterBook() {
      let filterWrapper = document.querySelectorAll('.input-button-flex');
      if (!filterWrapper.length) {
       return
      };
    
      for (let index = 0; index < filterWrapper.length; index++) {
       let butttonDownloadFile = filterWrapper[index].querySelector('.download-file');
       let contentItem = filterWrapper[index].querySelector('.filter');
       let contentTextItem = contentItem.querySelector('SPAN');
       let dropDownMenuItems = filterWrapper[index].querySelectorAll('.dropdown LI');
       let dropDownMenuItemsTitle = filterWrapper[index].querySelectorAll('.dropdown LI .title');
    
       contentItem.addEventListener('click', function (e) {
        e.preventDefault();
        contentItem.classList.toggle('active');
       });
    
       for (let i = 0; i < dropDownMenuItems.length; i++) {
        dropDownMenuItems[i].addEventListener('click', function (e) {
         e.preventDefault();
         contentItem.classList.remove('active');
         let hrefBook = dropDownMenuItems[i].getAttribute('data-link');
         butttonDownloadFile.href = hrefBook;
         contentTextItem.innerHTML = dropDownMenuItemsTitle[i].innerHTML;
        });
       };
      }
     }
    };
    
    /*
     * Tabs script
     */
    class MC_MoreText {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.moreTexts = $('a.readmore_text');
            if (this.moreTexts.length > 0) {
                this.initMoreTextsEvents();
            }
        }
    
        initMoreTextsEvents() {
            this.moreTexts.on('click', function(e){
                e.preventDefault();
                let moreContent = $(this).parent().find('.more-text');
                if(moreContent.length > 0){
                   moreContent.each(function(){
                       if($(this).hasClass('active')){
                           $(this).removeClass('active');
                       }
                       else{
                           $(this).addClass('active');
                       }
                   });
                }
            });
        }
    }
    
    class MC_VideoPopup {
        constructor() {
            this.initVideo();
        }
        initVideo() {
            var openPopups = $('.open-video-popup');
    
            if (!openPopups.length) {
                return;
            }
    
            for (var i = 0; i < openPopups.length; i++) {
                var overlay = openPopups.eq(i);
    
                openPopups.eq(i).on('click', function (e) {
                    e.preventDefault();
                    var stat_url = $(e.target).parent().attr('data-id');
                    var dataSrc = $(e.target).parents('.course-item').find('img').attr('data-src');
                    var videoPopup = $('#main').find('.video-popup');
                    var closePopup = videoPopup.find('.close-video-popup');
                    var videoPopupText = videoPopup.find('.text');
                    var iframe = $('#main').find('#video-popup-iframe');
                    videoPopup.addClass('is-open');
    
                    iframe.on('load', function () {
                        setTimeout(() => {
                            if (iframe.hasClass('video')) {
                                iframe[0].contentWindow.postMessage(JSON.stringify({
                                    'event': 'command',
                                    'func': 'playVideo',
                                    'args': []
                                }), '*');
                            } else {
                                iframe[0].contentWindow.postMessage('{ "method": "play" }', '*');
                            }
                        }, 500);
                    });
    
                    closePopup.on('click', function() {
                        videoPopup.removeClass('is-open');
                        videoPopupText.html('');
                        if (iframe.hasClass('video')) {
                            iframe[0].contentWindow.postMessage(JSON.stringify({
                                'event': 'command',
                                'func': 'pauseVideo',
                                'args': []
                            }), '*');
                        } else {
                            iframe[0].contentWindow.postMessage('{ "method": "pause" }', '*');
                        }
                    });
    
                    $(document).keyup(function(e) {
                        if (e.key === "Escape") { // escape key maps to keycode `27`
                            videoPopup.removeClass('is-open');
                            videoPopupText.html('');
    
                            if (iframe.hasClass('video')) {
                                iframe[0].contentWindow.postMessage(JSON.stringify({
                                    'event': 'command',
                                    'func': 'playVideo',
                                    'args': []
                                }), '*');
                            } else {
                                iframe[0].contentWindow.postMessage('{ "method": "pause" }', '*');
                            }
                        }
                    });
    
                    iframe.attr('src', dataSrc + '?enablejsapi=1');
    
                    if(stat_url != undefined && stat_url.length > 10){
                        $.ajax({
                            url: stat_url,
                            type: 'POST',
                            dataType: 'json'
                        });
                    }
                });
            }
        }
    }
    
    class MC_SliderDiplomas {
     constructor() {
      this.initSlider();
     }
     initSlider() {
      let slider = document.querySelector('.diplomas-covers-slider-wrapper-container');
      if (!slider){
         return
      }
      let sliderContainer = slider.querySelector('.diplomas-covers-slider');
      let sliderElement = slider.querySelectorAll('.diplomas-covers-slider LI');
      let sliderElementWidth = slider.querySelector('.diplomas-covers-slider LI').clientWidth + 10;
      let mobileViewport = window.matchMedia('(max-width: 580px)');
      let prevButton = slider.querySelector('.prev');
      let nextButton = slider.querySelector('.next');
      let currentSlide = 0;
      let stopSlide;
    
      if (!sliderContainer || !sliderElement.length) {
       return
      }
    
      function moveSlide() {
       sliderContainer.style.transform = `translateX(${-sliderElementWidth * currentSlide}px)`;
      }
    
      function autoPlay() {
       currentSlide++;
       if (!mobileViewport.matches) {
        if (currentSlide > sliderElement.length - 3) {
         currentSlide = 0;
        }
       } else {
        if (currentSlide > sliderElement.length - 2) {
         currentSlide = 0;
        }
       }
       moveSlide();
      }
    
      setInterval(function () {
       stopSlide = false;
       if (stopSlide === true) {
        setInterval(function (){
         stopSlide = false;
        }, 500)
       } else {
        autoPlay();
       }
      }, 6000)
    
      nextButton.addEventListener('click', function (e) {
       e.preventDefault();
       currentSlide++;
    
       stopSlide = true;
    
       if (!mobileViewport.matches) {
        if (currentSlide > sliderElement.length - 3) {
         currentSlide = 0;
        }
       } else {
        if (currentSlide > sliderElement.length - 2) {
         currentSlide = 0;
        }
       }
       moveSlide();
      })
    
      prevButton.addEventListener('click', function (e) {
       e.preventDefault();
       currentSlide--;
    
       stopSlide = true;
    
       if (!mobileViewport.matches) {
        if (currentSlide < 0) {
         currentSlide = sliderElement.length - 3;
        };
       } else {
        if (currentSlide < 0) {
         currentSlide = sliderElement.length - 2;
        }
       }
    
       moveSlide();
      })
     }
    }
    
    class MC_DiplomasChoice {
        constructor() {
         this.pickDiplom();
        }
    
        pickDiplom() {
         let diplomasContainer = document.querySelector('.templates-radio-list');
         if(!diplomasContainer) {
          return
         }
         let diplomasItem = diplomasContainer.querySelectorAll('.templates-radio-list LI INPUT');
         let formBlock = document.querySelector('.form-block');
    
         for (let i = 0; i < diplomasItem.length; i++) {
          diplomasItem[i].addEventListener('click', function() {
           let elementChoosen = diplomasItem[i].getAttribute('id');
           formBlock.querySelectorAll('.diploma-fields').forEach(element => {
            element.style.display = 'none';
           })
           formBlock.querySelector(`.${elementChoosen}`).style.display = 'block';
           formBlock.querySelectorAll(`.diploma-fields.${elementChoosen}`).forEach(element => {
            element.style.display = 'block';
           })
          })
         }
        }
       }
    
    class MC_ScrollToExpert {
     constructor() {
      this.initScroll();
     }
    
     initScroll() {
      let scrollButton = document.querySelector('.expert_biography');
      if(!scrollButton) {
       return
      }
      let scrollElement = document.querySelector('.article-expert');
      let header = document.querySelector('#header');
      scrollButton.addEventListener('click', function (e) {
       e.preventDefault();
       let scrollElementTop = scrollElement.getBoundingClientRect().top;
       let headerPosition = header.getBoundingClientRect().height;
       let positionScroll = scrollElementTop - headerPosition;
       window.scrollBy({
        top: positionScroll,
        behavior: 'smooth'
       })
      })
     }
    }
    
    class MC_TTPopup {
        constructor() {
            this.initPopup();
        }
    
        initPopup() {
            let buttonPopupInit = document.querySelectorAll('.trainer-dot');
            if (!buttonPopupInit.length) {
                return
            }
            let PopupWrappers = document.querySelectorAll('.tt-info-popup');
            if (!PopupWrappers.length) {
                return
            }
    
            for (let i = 0; i < buttonPopupInit.length; i++) {
                buttonPopupInit[i].addEventListener('click', function (e) {
                    e.preventDefault();
                    PopupWrappers.forEach(element => {
                        element.classList.remove('active');
                    })
                    let hrefElement = buttonPopupInit[i].getAttribute('data-id');
                    document.querySelector(`.tt-info-popup[data-tainer-id=${hrefElement}]`).classList.add('active');
                    document.querySelector(`.tt-info-popup[data-tainer-id=${hrefElement}]`).querySelector('.close').addEventListener('click', function (e) {
                        document.querySelector(`.tt-info-popup[data-tainer-id=${hrefElement}]`).classList.remove('active');
                    })
                })
            }
        }
    }
    
    class ME_Conference_Descriptions {
     constructor() {
      this.descShow();
     }
     descShow() {
      let popupConfContainer = document.querySelectorAll('.conference-program');
      if (!popupConfContainer.length) {
       return
      }
      for (let i = 0; i < popupConfContainer.length; i++) {
       let popupConfButtons = popupConfContainer[i].querySelectorAll('a[data-id]');
       let href;
       let item;
       let heigthShow;
    
       function openDescription(container) {
        item = document.querySelector(`${container}-${href}`);
        if (item.classList.contains('show')) {
         setTimeout(() => {
          item.classList.remove('show');
         }, 500);
         item.style.height = `${heigthShow}px`;
         setTimeout(() => {
          item.style.height = `0px`;
         }, 50);
        } else {
         setTimeout(() => {
          heigthShow = item.scrollHeight;
          item.classList.add('show');
          item.style.height = `${heigthShow}px`;
          setTimeout(() => {
           item.style.height = `auto`;
          }, 201);
         }, 200);
        }
       }
    
       popupConfButtons.forEach(element => {
        element.addEventListener('click', function (e) {
         e.preventDefault();
         href = element.getAttribute('data-id');
         element.classList.toggle('open');
         if (element.classList.contains('open-abstract')) {
          openDescription('.abstract')
         }
         if (element.classList.contains('open-bionote')) {
          openDescription('.bionote')
         }
        })
       })
      }
     }
    }
    
    class ME_CheckDownload {
     constructor() {
      this.checkUrlDownload();
     }
    
     checkUrlDownload() {
      let buttonDownload = document.querySelectorAll('.charts');
      if (buttonDownload.length < 0) {
       return
      }
      for (let i = 0; i < buttonDownload.length; i++) {
       buttonDownload[i].addEventListener('click', function () {
        let hrefD = buttonDownload[i].getAttribute('href');
        buttonDownload[i].innerHTML = '';
        buttonDownload[i].classList.add('loading');
        var startTime = new Date().getTime();
    
        fetch(`${hrefD}`)
         .then(response => {
          var endTime = new Date().getTime();
          var downloadTime = endTime - startTime;
          setTimeout(() => {
           buttonDownload[i].classList.remove('loading');
           buttonDownload[i].innerHTML = 'Raport został pobrany';
           buttonDownload[i].setAttribute('disabled', true);
           setTimeout(() => {
            buttonDownload[i].innerHTML = 'Pobierz raport w PDF';
            buttonDownload[i].removeAttribute('disabled');
           }, 3000);
          }, downloadTime);
          return response
         })
         .catch(error => {
          console.error('Wystąpił błąd:', error);
         });
       })
      }
     }
    }
    
    
    
    class ME_FormDeclaration {
        constructor() {
            this.formRegister();
            this.formUpdate();
            this.formDeclaration();
        }
    
        formRegister() {
            let registerBtn = document.querySelector("#register-button");
            if (!registerBtn) {
                return
            }
            registerBtn.addEventListener('click', function (e) {
                e.preventDefault();
                let formRegisterNew = document.getElementById("form-register-conference");
                let submitEventR = new Event('submit', {
                    bubbles: true,
                    cancelable: true
                });
                formRegisterNew.dispatchEvent(submitEventR);
                formRegisterNew.submit();
            });
        }
    
        formUpdate() {
            let updateBtn = document.querySelector("#annual-update-form-btn");
            if (!updateBtn) {
                return
            }
            updateBtn.addEventListener('click', function (e) {
                e.preventDefault();
                let formUpdateNew = document.getElementById("annual-update-form");
                let submitEventU = new Event('submit', {
                    bubbles: true,
                    cancelable: true
                });
                formUpdateNew.dispatchEvent(submitEventU);
                formUpdateNew.submit();
            });
        }
    
        formDeclaration() {
            let declarationBtn = document.querySelector("#form-declaration-btn");
            if (!declarationBtn) {
                return
            }
            declarationBtn.addEventListener('click', function (e) {
                e.preventDefault();
                let formDeclarationNew = document.getElementById("form-declaration");
                let submitEventD = new Event('submit', {
                    bubbles: true,
                    cancelable: true
                });
                formDeclarationNew.dispatchEvent(submitEventD);
                formDeclarationNew.submit();
            });
        }
    }
    
    class ME_BookSlider {
        constructor() {
            this.bookSlider();
        }
    
        bookSlider() {
            let examsSlider = document.querySelectorAll('.exams-slider');
            if (examsSlider.length > 0) {
                for (let i = 0; i < examsSlider.length; i++) {
                    let examSliderList = examsSlider[i].querySelector('.exams-slider-list');
                    let examsSliderItems = examSliderList.querySelectorAll('li');
                    let examsSliderItemWidth;
                    let prev = examsSlider[i].querySelector('.prev');
                    let next = examsSlider[i].querySelector('.next');
                    let mediaMobile = window.matchMedia('(max-width: 600px)');
                    let currentSlide = 0;
    
                    function countQuery() {
                        if (mediaMobile.matches) {
                            examsSliderItemWidth = examSliderList.querySelector('li').getBoundingClientRect().width;
                            return 1;
                        } else {
                            examsSliderItemWidth = examSliderList.querySelector('li').getBoundingClientRect().width + 15;
                            return 3;
                        }
                    }
    
                    function moveSlide() {
                        examSliderList.style.transform = `translateX(${-examsSliderItemWidth * currentSlide}px)`;
                    }
    
                    next.addEventListener('click', function (e) {
                        e.preventDefault();
                        currentSlide++;
                        if (currentSlide > examsSliderItems.length - countQuery()) {
                            currentSlide = 0;
                        }
                        moveSlide()
                    })
    
    
                    prev.addEventListener('click', function (e) {
                        e.preventDefault();
                        currentSlide--;
                        if (currentSlide < 0) {
                            currentSlide = examsSliderItems.length - countQuery();
                        }
                        moveSlide()
                    })
                }
            }
        }
    }
    

    new ME_UI();
    new ME_Menu();
    new ME_Search();
    new ME_FormHelper;
    new ME_CoverTabs();
    new ME_HomeArticlesSlider();
    new ME_ArticlesSlider();
    new ME_TrainingsSlider();
    new ME_ReviewsSlider();
    new ME_SliderTT();
    new ME_Product()
    new ME_Forms();
    new ME_Quizlet();
    new ME_BTSFormRegister();
    new ME_Tabs();
    new ME_RepoForm();
    new ME_StepsCircleForm();
    new ME_Accordions();
    new ME_Submenu();
    new ME_AddClass();
    new MC_TabsSchool();
    new MC_MoreText();
    new MC_VideoPopup();
    new MC_SliderDiplomas();
    new MC_DiplomasChoice();
    new MC_ScrollToExpert();
    new MC_TTPopup();
    new ME_Conference_Descriptions();
    new ME_CheckDownload();
    new ME_FormDeclaration();
    new ME_BookSlider();

    var lightbox = new PhotoSwipeLightbox({
        gallery: '.product-panel__gallery__images',
        children: 'a',
        spacing: 0.5,
        opacity: 0.5,
        pswpModule: PhotoSwipe
    });
    lightbox.init();


    let sliders = $('section.section-teacherzone-slider');
    sliders.each(function () {
        new ME_TeacherzoneSlider($(this));
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
})();

function __debounce(func, wait, immediate) {
    var timeout;

    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function coookiesClosed() {
    let cookiesContainer = document.querySelector('#cookies-policy');
    if (!cookiesContainer) {
        return
    } else {
        cookiesContainer.querySelector(".close").addEventListener('click', function () {
            cookiesContainer.classList.add('hide');
        })
    }
}
coookiesClosed()

function teacherzoneSmallSlider() {
    let teacherzoneSmallSlider = document.querySelectorAll('.section-teacherzone-small-slider');
    if (teacherzoneSmallSlider.length > 0) {
        for (let slider = 0; slider < teacherzoneSmallSlider.length; slider++) {
            let detailsSlider = teacherzoneSmallSlider[slider].querySelector('.details-slider');
            if (detailsSlider) {
                let showAllButton = teacherzoneSmallSlider[slider].querySelector('.show-all');
                let showAllButtonAll = teacherzoneSmallSlider[slider].querySelector('.all');
                let showAllButtonLess = teacherzoneSmallSlider[slider].querySelector('.less');

                if (showAllButton) {
                    showAllButton.addEventListener('click', function (e) {
                        e.preventDefault();
                        if (currentSlide !== 0) {
                            sliderEl.style.transform = `translateX(0)`;
                            currentSlide = 0;
                            prev.style.display = "none";
                            setTimeout(() => {
                                teacherzoneSmallSlider[slider].classList.toggle('show-all');
                            }, 500);
                        } else {
                            teacherzoneSmallSlider[slider].classList.toggle('show-all');
                        }



                        if (teacherzoneSmallSlider[slider].classList.contains('show-all')) {
                            showAllButtonLess.style.display = "inline-block"
                            showAllButtonAll.style.display = "none"
                        } else {
                            showAllButtonLess.style.display = "none"
                            showAllButtonAll.style.display = "inline-block"
                            next.style.display = "flex";

                            teacherzoneSmallSlider[slider].scrollIntoView({ block: "start", behavior: "smooth" })
                        }
                    })
                }

                let sliderEl = detailsSlider.querySelector('.slider');
                let sliderItems = sliderEl.querySelectorAll(':scope > li');
                let sliderItemWidth = sliderEl.querySelector('li').getBoundingClientRect().width + 20;
                let prev = detailsSlider.querySelector('.prev');
                let next = detailsSlider.querySelector('.next');
                let currentSlide = 0;
                let mediaQueryFullHd = window.matchMedia('all and (min-width:1101px)');
                let mediaQueryDesktop = window.matchMedia('all and (min-width:781px) and (max-width: 1100px)');
                let mediaQueryTablet = window.matchMedia('all and (min-width:421px) and (max-width: 780px)');
                let mediaQueryPhone = window.matchMedia('all and (max-width: 420px)');

                function calculateCurrentSlide() {
                    if (mediaQueryFullHd.matches) {
                        return 4
                    } else if (mediaQueryDesktop.matches) {
                        return 3
                    } else if (mediaQueryTablet.matches) {
                        return 2
                    } else if (mediaQueryPhone.matches) {
                        return 1
                    }
                }

                function moveSlide() {
                    sliderEl.style.transform = `translateX(${-sliderItemWidth * currentSlide}px)`;
                }

                if (currentSlide <= 0) {
                    prev.style.display = "none";
                }

                next.addEventListener('click', function (e) {
                    e.preventDefault();
                    prev.style.display = "flex";
                    currentSlide++;

                    if (currentSlide >= sliderItems.length - calculateCurrentSlide()) {
                        next.style.display = "none";
                    }
                    moveSlide();
                })

                prev.addEventListener('click', function (e) {
                    e.preventDefault();
                    next.style.display = "flex";
                    currentSlide--;

                    if (currentSlide <= 0) {
                        prev.style.display = "none";
                    }

                    moveSlide();
                })
            }
        }
    }
}
teacherzoneSmallSlider()
